import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    View,
    FlatList,
    ScrollView,
    TouchableOpacity,
    KeyboardAvoidingView,
    ActivityIndicator,
    processColor
} from "react-native";


import {moderateScale} from '../../../../../tools/Scaling';


import HMActionBar from "../../../../../customviews/HMActionBar";


import i18n from '../../../../../I18n/i18n.js';

const SLIDER_1_FIRST_ITEM = 1;

import * as NavigationService from "../../../../../redux/NavigationService";
import DialogLoadingCustomize from "../../../../../customviews/DialogLoadingCustomize";
import {Tools} from "../../../../../tools/Tools";
import HMTextView from "../../../../../customviews/HMTextView";
import Colors from "../../../../../tools/Colors";
import {typeExport} from "../../../../../redux/store/type";

import HMLoading from "../../../../../customviews/HMLoading";

import DialogConnectionCustomize from "../../../../../customviews/DialogConnectionCustomize";
import store from "../../../../../redux/store";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";
import HMAlert from "../../../../../customviews/HMAlert";

let container = null;

import {connect} from "react-redux";
import HMLineChart from "../../../../../customviews/chart/HMLineChart";
import axios from "axios";
import HMSelectInput from "../../../../../customviews/HMSelectInput";
import HMIcon from "../../../../../customviews/HMIcon";
import HMFlatList from "../../../../../customviews/HMFlatList";
import HMGroupBarChart from "../../../../../customviews/chart/HMGroupBarChart";

class DashboardMyStateScreen extends Component {


    constructor(props) {
        super(props);
        container = this;

        let viewportWidth = 1;
        let viewportHeight = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.documentElement.clientWidth;
            viewportHeight = document.documentElement.clientHeight;


        }
        // switch (Platform.OS) {
        //
        //     case "android":
        //         firebase = require("react-native-firebase")
        //
        //         break;
        //     default:
        //
        // }
        // if (Platform.OS === "android") {
        //      firebase = require("react-native-firebase")
        //
        // }
        let checkSmall = Platform.OS === "web" ? viewportWidth <= 900 : true;
        this.state = {


            columnCount: 2,
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,
            isLoading: false,
            alaki: false,
            viewportWidth: viewportWidth,
            viewportHeight: viewportHeight,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 900 ? 480 : viewportWidth) : typeExport._WIDTH,
            arraySelectCheckBoxGender: [],

            Place: null,
            SelectPlaceValue: null,
            listPlace: [],

            Month4: {
                label: "فروردین",
                value: "فروردین",
                index: 0
            },
            SelectMonthValue4: "فروردین",

            Month10: {
                label: "فروردین",
                value: "فروردین",
                index: 0
            },
            SelectMonthValue10: "فروردین",
            listMonth: [
                {
                    label: "فروردین",
                    value: "فروردین",
                },
                {
                    label: "اردیبهشت",
                    value: "اردیبهشت",
                },
                {
                    label: "خرداد",
                    value: "خرداد",
                },
                {
                    label: "تیر",
                    value: "تیر",
                },
                {
                    label: "مرداد",
                    value: "مرداد",
                },
                {
                    label: "شهریور",
                    value: "شهریور",
                },
                {
                    label: "مهر",
                    value: "مهر",
                },
                {
                    label: "آبان",
                    value: "آبان",
                },
                {
                    label: "آذر",
                    value: "آذر",
                },
                {
                    label: "دی",
                    value: "دی",
                },
                {
                    label: "بهمن",
                    value: "بهمن",
                },
                {
                    label: "اسفند",
                    value: "اسفند",
                },

            ],

            smallView: checkSmall


        };
        this.props.navigation.addListener('focus', () => {


                this.setState({
                    alaki: !this.state.alaki,
                })
                container = this;
            }
        )
        this.props.navigation.addListener('blur', () => {
        })


    }


    componentDidMount() {
        if (Platform.OS === "web") {
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;
                //  let checkLarge = viewportWidth > 900;
                let checkSmall = viewportWidth <= 900;
                container.setState({
                        viewportWidth: viewportWidth,
                        viewportHeight: viewportHeight,
                    },
                )
                if (!checkSmall && container.state.smallView) {
                    container.setState({
                            smallView: false,
                            viewportWidth: viewportWidth,
                            // itemWidth: viewportWidth > 900 ? 480 : viewportWidth,
                            // columnCount: viewportWidth > 1000 ? 2 : 1,
                        },
                    )
                }
                else if (checkSmall && !container.state.smallView) {
                    container.setState({
                            smallView: true,
                            viewportWidth: viewportWidth,
                            // itemWidth: viewportWidth > 900 ? 480 : viewportWidth,
                            // columnCount: viewportWidth > 1000 ? 2 : 1,
                        },
                    )
                }


            })
        }
        this.getDataDashboard();


        this.unsubscribeFromNotificationListener = Tools.receiveonOnNotification(this.changeMenu)

    }

    changeMenu() {
        container.setState({alaki: !container.state.alaki})
    }

    getData() {
        let {mobile, password} = this.state;

        let paramss = {
            "_operation": typeExport._Shahrdar,

            "mode": typeExport._GetCalendar,
            "lang": i18n.locale,

            //    "username": mobile,
            //  "password": password,
            //
            // "username": Tools.persianToEnglish(mobile),
            // "password": Tools.persianToEnglish(password),
            // "token_fb": this.props.DataSplashScreen.token_fb,
        };
        paramss = Tools.addAllParams(paramss);
        this.props.callService(
            typeExport.urlApplyScreen,
            paramss,
            typeExport.TypeGetApplyScreen,
            "POST",
            this.state
        );

    }

    componentWillUnmount() {

        if (Platform.OS === 'android') {
            this.unsubscribeFromNotificationListener();
        }
    }

    render() {
        let {viewportWidth, viewportHeight, Month4, Month10, SelectMonthValue4, SelectMonthValue10, listMonth, Place, SelectPlaceValue, listPlace, smallView, widgets} = this.state;
        let list = this.props.route.params ? this.props.route.params.list : null;
        let _params = this.props.route.params;
        let item = _params.item;
        let CustomView = 1 === 1 ? TouchableOpacity : View;


        let renderWidgets = (data) => {
            switch (data.type) {

                case "widget-1":

                    return <View
                        style={{
                            // flex: !smallView ? .5 : 1,
                            width: !smallView ? "49%" : "98%",
                            marginHorizontal: moderateScale(2),
                            marginVertical: moderateScale(4),

                            minHeight: moderateScale(240),
                            maxHeight: moderateScale(700),
                            // width: viewportWidth/(!smallView ? 2 : 1),
                            //  height: moderateScale(700) / 2,
                            // width: viewportWidth/(!smallView ? 2 : 1),
                            // height: viewportWidth/(!smallView ? 4 : 2),
                            overflow: "hidden",
                            /// backgroundColor: "#1f00ee",


                        }}>
                        {
                            this.state.dataChart ?
                                <HMLineChart
                                    dataChart={this.state.dataChart}
                                    // title={"درصد رضایت کسب شده در مقایسه با مناطق"}
                                    title={data.name}
                                />
                                :
                                null
                        }

                    </View>;
                case "widget-2":
                    return <View
                        style={{
                            // flex: !smallView ? .5 : 1,
                            width: !smallView ? "49%" : "98%",
                            marginHorizontal: moderateScale(2),
                            marginVertical: moderateScale(4),
                            minHeight: moderateScale(450 / (smallView ? 1.6 : 1)),
                            maxHeight: moderateScale(700),

                            //  width: viewportWidth/(!smallView ? 2 : 1),
                            //  height: viewportWidth/(!smallView ? 4 : 2),

                            //  height: moderateScale(700) / 2,

                            overflow: "hidden",
                            /// backgroundColor: "#1f00ee",


                        }}>
                        {
                            this.state.dataChart2 ?
                                <HMLineChart
                                    dataChart={this.state.dataChart2}
                                    // title={"درصد رضایت کسب شده"}
                                    title={data.name}
                                />
                                :
                                null
                        }

                    </View>;
                case "widget-3" :
                    return <View
                        style={{
                            // width: viewportWidth/(!smallView ? 2 : 1),
                            width: !smallView ? "49%" : "98%",
                            marginHorizontal: moderateScale(2),
                            marginVertical: moderateScale(4),

                            // flex: !smallView ? .5 : 1,
                            minHeight: moderateScale(240),
                            maxHeight: moderateScale(700),

                            //height: moderateScale(700) / 2,

                            overflow: "hidden",
                            //  backgroundColor: "#1f00ee",

                        }}>
                        {
                            this.state.dataChartGroupBarChart ?

                                <HMGroupBarChart
                                    dataChart={this.state.dataChartGroupBarChart}
                                    item={[]}
                                    /*    item={[
                                            {
                                                "NAME": "INTERNET",
                                                "FNAME": "اینترنت بین الملل",
                                                "IN": 5659874562,
                                                "OUT": 15987453214,
                                                "CREDITUSED": 125645,
                                                "URL": ""
                                            },
                                            {
                                                "NAME": "INTERNAL",
                                                "FNAME": "سایت های داخلی",
                                                "IN": 12548963584,
                                                "OUT": 1358745699,
                                                "CREDITUSED": 266412,
                                                "URL": "https:\/\/icip.ito.gov.ir\/index.php\/site\/page\/view\/list_ip"
                                            },
                                            {
                                                "NAME": "VOD",
                                                "FNAME": "تلویزیون اینترنتی",
                                                "IN": 28656487543,
                                                "OUT": 3258457896,
                                                "CREDITUSED": 125874,
                                                "URL": "https:\/\/icip.ito.gov.ir\/index.php\/site\/page\/view\/list_ip"
                                            },
                                            {
                                                "NAME": "SATIA",
                                                "FNAME": "رایگانها",
                                                "IN": 895656456,
                                                "OUT": 655646,
                                                "CREDITUSED": 148759,
                                                "URL": ""
                                            },
                                            {
                                                "NAME": "MESSENGER",
                                                "FNAME": "پیام رسان داخلی",
                                                "IN": 64645655,
                                                "OUT": 0,
                                                "CREDITUSED": 64587,
                                                "URL": ""
                                            }
                                        ]}*/
                                    // title={"درصد امتیاز کسب شده در مقایسه با مناطق"}
                                    title={data.name}
                                />
                                :
                                null
                        }

                    </View>;
                case "widget-4" :
                    return <View
                        style={{
                            // width: viewportWidth/(!smallView ? 2 : 1),
                            width: !smallView ? "49%" : "98%",
                            marginHorizontal: moderateScale(2),
                            marginVertical: moderateScale(4),

                            // flex: !smallView ? .5 : 1,
                            minHeight: moderateScale(450 / (smallView ? 1.6 : 1)),

                            maxHeight: moderateScale(700),

                            //height: moderateScale(700) / 2,

                            overflow: "hidden",
                            //  backgroundColor: "#1f00ee",

                        }}>
                        {
                            this.state.dataChart3 ?
                                <HMLineChart
                                    dataChart={this.state.dataChart3}
                                    //  title={"درصد رضایت کسب شده"}
                                    title={data.name}
                                />
                                :
                                null
                        }


                    </View>;
                case "widget-5":
                    return <View
                        style={{
                            width: "100%",

                            marginBottom: moderateScale(14)
                        }}>

                        <View style={{flexDirection: "row", alignSelf: "center"}}>
                            <HMTextView
                                // numberOfLines={2}
                                type={"bold"}
                                //text={"4 گروه موضوع اصلی " + Place?.name}
                                text={data.name + " " + Place?.name}
                                style={{
                                    fontSize: moderateScale(16),

                                    color: Colors.blackLight,


                                    // textDecorationColor: "#000"
                                }}
                                styleRoot={{alignSelf: "center"}}
                            />
                            <HMSelectInput
                                onValueChange={(value) => {


                                    let idx = container.state.listMonth.findIndex(obj => obj.value == value);
                                    let res = null;
                                    if (idx !== -1) {
                                        res = container.state.listMonth[idx]
                                    }
                                    let resultMonth = this.getMonthChartValue(value);
                                    // let resultSubjectList10 = this.state.listSubjectList10?.find(k => k.month.search('-' + resultMonth) >= 0);
                                    let resultSubjectList4 = this.state.listSubjectList4?.find(k => k.month.search('-' + resultMonth) >= 0);
                                    this.setState({
                                            SelectMonthValue4: value,
                                            Month4: res ? {
                                                ...res,
                                                index: idx
                                            } : {
                                                label: "یک مورد را انتخاب نمایید ...",
                                                value: idx,
                                                index: idx
                                            }
                                        },

                                        () => {
                                            this.setState({
                                                // SubjectList10: resultSubjectList10?.subjects,
                                                SubjectList4: resultSubjectList4?.subjects,


                                            })

                                        }
                                    )
                                }}
                                // error={this.state.errorSelectInput}
                                //
                                // //  requestServerRetry={container.getServerTypeDocuments}
                                // requestServer={() => {
                                // }}
                                // value={SelectMonthValue ? "" : "یک مورد را انتخاب نمایید ..."}
                                value={SelectMonthValue4 !== null ? SelectMonthValue4 : i18n.t('constant.SelectItem')}

                                defaultValue={"یک مورد را انتخاب نمایید ..."}
                                index={Month4 ? Month4.index : -1}
                                itemSelectInput={Month4}
                                options={listMonth}

                                styleRoot={[{
                                    //width: '100%',
                                    margin: moderateScale(8),
                                    marginTop: moderateScale(14)
                                    //    height: '100%'
                                }, Platform.OS === "web" ? {} : {width: moderateScale(140),}]}
                            />
                        </View>
                        <View
                            style={{
                                width: "100%",
                                /// flex:1,
                                flexDirection: 'row',

                                marginTop: moderateScale(2),
                                // marginEnd: moderateScale(Platform.OS == "web" ? 10 : 0)
                                //  paddingEnd: moderateScale((Platform.OS === "web" && !(isMobile)) ? moderateScale(12) : 0),
                                // alignSelf: 'center'
                                // marginVertical:moderateScale(6),
                            }}>
                            <View
                                style={{
                                    width: '100%',
                                    /// flex:1,
                                    flexDirection: 'row',
                                    backgroundColor: "#174C72",
                                    marginTop: moderateScale(2),
                                    // marginEnd: moderateScale(Platform.OS == "web" ? 10 : 0)
                                    // paddingEnd: moderateScale(Platform.OS === "web" && !(navigator.userAgentData && navigator.userAgentData.mobile) ? 18 : 0),
                                    // marginEnd: moderateScale(Platform.OS == "web" ? 10 : 0)

                                    // alignSelf: 'center'
                                    // marginVertical:moderateScale(6),
                                }}>
                                <View style={{
                                    flex: .4,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginVertical: moderateScale(2),
                                    //paddingHorizontal:moderateScale(4)

                                }}>
                                    <HMTextView
                                        // numberOfLines={2}
                                        type={"bold"}
                                        text={"موضوع"}
                                        style={{
                                            fontSize: moderateScale(13),

                                            color: Colors.white
                                            //  marginTop: moderateScale(4),
                                            //  textAlign: "right",
                                        }}/>
                                </View>
                                <View style={{
                                    height: '100%',
                                    width: moderateScale(1),
                                    alignSelf: 'center',
                                    backgroundColor: Colors.colorDark
                                }}/>

                                <View style={{
                                    flex: .15,
                                    //flexDirection: "row",
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <HMTextView
                                        // numberOfLines={2}
                                        type={"bold"}
                                        text={"تعداد"}
                                        style={{
                                            fontSize: moderateScale(13),

                                            color: Colors.white,
                                            //  marginTop: moderateScale(4),
                                            textAlign: "center",

                                        }}/>

                                    <HMIcon
                                        type={"MaterialCommunityIcons"}

                                        name={(this.state.typeSort === "count" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                        style={{
                                            color: (this.state.typeSort === "count") ? "#ffffff" : "#ffffff",
                                            fontSize: moderateScale(28),
                                            //  padding: moderateScale(4),
                                            alignSelf: "center",
                                        }}
                                        onPress={() => {
                                            let Sort = (this.state.typeSort === "count" && this.state.typeOrder === "desc") ? "asc" : "desc";
                                            this.setState({
                                                    typeOrder: Sort,
                                                    typeSort: "count",

                                                },
                                                () => {
                                                    let res = Tools.getSortList(this.state.SubjectList4, "total_count", "total_count", Sort);
                                                    this.setState({
                                                        SubjectList4: res,
                                                        alaki: !this.state.alaki
                                                    })
                                                }
                                            )
                                        }}

                                    />
                                </View>
                                <View style={{
                                    height: '100%',
                                    width: moderateScale(1),
                                    alignSelf: 'center',
                                    backgroundColor: Colors.colorDark
                                }}/>
                                <View
                                    style={{
                                        flex: .15,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                    <HMTextView
                                        // numberOfLines={2}
                                        type={"bold"}
                                        text={"دردست اقدام"}
                                        style={{
                                            fontSize: moderateScale(13),

                                            color: Colors.white,
                                            //  marginTop: moderateScale(4),
                                            textAlign: "center",
                                        }}/>
                                    <HMIcon
                                        type={"MaterialCommunityIcons"}

                                        name={(this.state.typeSort === "doing" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                        style={{
                                            color: (this.state.typeSort === "doing") ? "#ffffff" : "#ffffff",
                                            fontSize: moderateScale(28),
                                            //  padding: moderateScale(4),
                                            alignSelf: "center",
                                        }}
                                        onPress={() => {
                                            let Sort = (this.state.typeSort === "doing" && this.state.typeOrder === "desc") ? "asc" : "desc";

                                            this.setState({
                                                    typeOrder: Sort,
                                                    typeSort: "doing",

                                                },
                                                () => {
                                                    let res = Tools.getSortList(this.state.SubjectList4, "inprogress_percentage", "inprogress_percentage", Sort);
                                                    this.setState({
                                                        SubjectList4: res,
                                                        alaki: !this.state.alaki
                                                    })
                                                }
                                            )
                                        }}

                                    />
                                </View>

                                <View
                                    style={{
                                        height: '100%',
                                        width: moderateScale(1),
                                        alignSelf: 'center',
                                        backgroundColor: Colors.colorDark
                                    }}/>
                                <View
                                    style={{
                                        flex: .15,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}

                                >
                                    <View

                                        onPress={() => {
                                            this.setState({
                                                resultModal: this.props.resultsAll.done,
                                                visibleModal: "Details"
                                            })

                                        }}
                                    >
                                        <HMTextView
                                            // numberOfLines={2}
                                            type={"bold"}
                                            text={"انجام شده ها"}
                                            style={[{
                                                fontSize: moderateScale(13),

                                                color: Colors.white,
                                                //  marginTop: moderateScale(4),
                                                // textAlign: "center",
                                                // textDecorationLine: "underline",
                                                // textDecorationStyle: "solid",
                                                // textDecorationColor: "#000"
                                            }
                                            ]}/>
                                    </View>
                                    <HMIcon
                                        type={"MaterialCommunityIcons"}

                                        name={(this.state.typeSort === "done" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                        style={{
                                            color: (this.state.typeSort === "done") ? "#ffffff" : "#ffffff",
                                            fontSize: moderateScale(28),
                                            //  padding: moderateScale(4),
                                            alignSelf: "center",
                                        }}
                                        onPress={() => {
                                            let Sort = (this.state.typeSort === "done" && this.state.typeOrder === "desc") ? "asc" : "desc";
                                            this.setState({
                                                    typeOrder: Sort,
                                                    typeSort: "done",

                                                },
                                                () => {
                                                    let res = Tools.getSortList(this.state.SubjectList4, "done_percentage", "done_percentage", Sort);
                                                    this.setState({
                                                        SubjectList4: res,
                                                        alaki: !this.state.alaki
                                                    })
                                                    // this.getData(1)
                                                }
                                            )
                                        }}

                                    />
                                </View>
                                <View
                                    style={{
                                        height: '100%',
                                        width: moderateScale(1),
                                        alignSelf: 'center',
                                        backgroundColor: Colors.colorDark
                                    }}/>
                                <View
                                    style={{
                                        flex: .15,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}

                                >
                                    <View
                                        onPress={() => {
                                            this.setState({
                                                resultModal: this.props.resultsAll.others,
                                                visibleModal: "Details"
                                            })

                                        }}
                                    >
                                        <HMTextView
                                            // numberOfLines={2}
                                            type={"bold"}
                                            text={"سایر"}
                                            style={{
                                                fontSize: moderateScale(13),

                                                color: Colors.white,
                                                //  marginTop: moderateScale(4),
                                                // textAlign: "center",
                                                // textDecorationLine: "underline",
                                                // textDecorationStyle: "solid",
                                                // textDecorationColor: "#000"
                                            }}/>
                                    </View>
                                    <HMIcon
                                        type={"MaterialCommunityIcons"}

                                        name={(this.state.typeSort === "other" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                        style={{
                                            color: (this.state.typeSort === "other") ? "#ffffff" : "#ffffff",
                                            fontSize: moderateScale(28),
                                            //  padding: moderateScale(4),
                                            alignSelf: "center",
                                        }}
                                        onPress={() => {
                                            let Sort = (this.state.typeSort === "other" && this.state.typeOrder === "desc") ? "asc" : "desc";
                                            this.setState({
                                                    typeOrder: Sort,
                                                    typeSort: "other",

                                                },
                                                () => {
                                                    let res = Tools.getSortList(this.state.SubjectList4, "other_percentage", "other_percentage", Sort);
                                                    this.setState({
                                                        SubjectList4: res,
                                                        alaki: !this.state.alaki
                                                    })
                                                }
                                            )
                                        }}

                                    />
                                </View>


                            </View>

                        </View>
                        <View
                            style={{
                                flex: 1,
                                //alignItems: "center",
                            }}>


                            {
                                this.state.SubjectList4 ?
                                    <HMFlatList
                                        ref={(ref) => {
                                            this.list1 = ref && ref.flatListRef?.current;
                                        }}
                                        keyExtractor={(item, index) => index.toString() + item.subject_name}
                                        // keyExtractor={(item, index) => index.toString() + (Place.top_subject_groups?.length)}
                                        extraData={{
                                            alaki: this.state.alaki,
                                            // SubjectList4: this.state.SubjectList4,
                                        }}
                                        data={this.state.SubjectList4 ? this.state.SubjectList4 : []}
                                        renderItem={({item, index}) => {
                                            let mode = true
                                            // if (Platform.OS !== "web") {
                                            //     item = type.item;
                                            //     index = type.index;
                                            // }
                                            //if (index === 0)
                                            return <View
                                                style={{
                                                    width: "100%",
                                                    // flex: 1,
                                                    overflow: 'hidden',
                                                    //    height: HeightItem,
                                                    // padding: moderateScale(4),
                                                    //  margin:moderateScale(5),
                                                    borderWidth: moderateScale(1),
                                                    // borderRadius: moderateScale(2),
                                                    borderColor: '#ddd',
                                                    // borderBottomWidth: 0,
                                                    // shadowColor: '#000',
                                                    // shadowOffset: {width: 0, height: moderateScale(.7)},
                                                    // shadowOpacity: 0.6,
                                                    // shadowRadius: moderateScale(2),
                                                    elevation: moderateScale(1),
                                                    // marginLeft: moderateScale(1),
                                                    // marginRight: moderateScale(1),
                                                    // marginTop: moderateScale(1),
                                                    // marginBottom: moderateScale(1),
                                                    backgroundColor: Colors.white,
                                                }}>
                                                <View
                                                    style={{
                                                        width: '100%',
                                                        flexDirection: 'row',
                                                        backgroundColor: Colors.white,


                                                        // alignSelf: 'center'
                                                        // marginVertical:moderateScale(6),
                                                    }}>


                                                    <View
                                                        style={{
                                                            flex: .4,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(8),
                                                            //  paddingHorizontal: moderateScale(4)
                                                        }}

                                                    >
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={item.name ? item.name : item.subject_name}
                                                            style={{
                                                                fontSize: moderateScale(13),

                                                                color: Colors.blue,
                                                                // textDecorationLine: "underline",
                                                                // textDecorationStyle: "solid",
                                                                //  marginTop: moderateScale(4),
                                                                //  textAlign: "right",
                                                            }}/>
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>

                                                    <CustomView
                                                        style={{
                                                            flex: .15,
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                        activeOpacity={mode ? .2 : 1}

                                                    >
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={item.count ? item.count : item.total_count}
                                                            style={[{
                                                                fontSize: moderateScale(14),


                                                                //  marginTop: moderateScale(4),
                                                                textAlign: "center",


                                                            }, mode ? {
                                                                color: Colors.blackLight,
                                                                // textDecorationLine: "underline",
                                                                // textDecorationStyle: "solid",
                                                            } : {color: Colors.blackLight,}]}/>
                                                    </CustomView>

                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View
                                                        style={{
                                                            flex: .15,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(2)
                                                        }}>

                                                        <CustomView
                                                            style={{
                                                                flex: .15,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                            activeOpacity={mode ? .2 : 1}

                                                        >

                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                //text={(((item.doing ? item.doing : item.inprogress_count) / (item.count ? item.count : item.total_count)) * 100) + "%"}
                                                                //  text={Tools.getPercentage((item.doing ? item.doing : item.inprogress_count), (item.count ? item.count : item.total_count)) + "%"}
                                                                text={item.inprogress_percentage + "%"}
                                                                style={[{
                                                                    fontSize: moderateScale(14),


                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",


                                                                }, mode ? {
                                                                    color: Colors.blackLight,
                                                                    // textDecorationLine: "underline",
                                                                    // textDecorationStyle: "solid",
                                                                } : {color: Colors.blackLight,}]}/>
                                                        </CustomView>

                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View
                                                        style={{
                                                            flex: .15,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(2)
                                                        }}>
                                                        <CustomView
                                                            style={{
                                                                flex: .15,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                            activeOpacity={mode ? .2 : 1}

                                                        >

                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                //   text={(item.done ? item.done : item.done_count) + "%"}
                                                                //   text={Tools.getPercentage((item.done ? item.done : item.done_count), (item.count ? item.count : item.total_count)) + "%"}
                                                                text={item.done_percentage + "%"}

                                                                style={[{
                                                                    fontSize: moderateScale(14),


                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",


                                                                }, mode ? {
                                                                    color: Colors.blackLight,
                                                                    // textDecorationLine: "underline",
                                                                    // textDecorationStyle: "solid",
                                                                } : {color: Colors.blackLight,}]}/>
                                                        </CustomView>

                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View
                                                        style={{
                                                            flex: .15,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(2)
                                                        }}>
                                                        <CustomView
                                                            style={{
                                                                flex: .15,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                            activeOpacity={mode ? .2 : 1}

                                                        >

                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                //    text={(item.other ? item.other : item.other_count) + "%"}
                                                                //   text={Tools.getPercentage((item.other ? item.other : item.other_count), (item.count ? item.count : item.total_count)) + "%"}
                                                                text={item.other_percentage + "%"}

                                                                style={[{
                                                                    fontSize: moderateScale(14),


                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",


                                                                }, mode ? {
                                                                    color: Colors.blackLight,
                                                                    // textDecorationLine: "underline",
                                                                    // textDecorationStyle: "solid",
                                                                } : {color: Colors.blackLight,}]}/>
                                                        </CustomView>

                                                    </View>
                                                </View>

                                            </View>
                                        }}

                                    />
                                    :
                                    null
                            }


                        </View>
                    </View>;
                case "widget-6":
                    return <View
                        style={{
                            width: "100%",

                            marginVertical: moderateScale(14)
                        }}>
                        <View style={{flexDirection: "row", alignSelf: "center"}}>
                            <HMTextView
                                // numberOfLines={2}
                                type={"bold"}
                                //  text={"10 گروه موضوع اصلی " + Place?.name}
                                text={data.name + " " + Place?.name}

                                style={{
                                    fontSize: moderateScale(16),

                                    color: Colors.blackLight,


                                    // textDecorationColor: "#000"
                                }}
                                styleRoot={{alignSelf: "center"}}
                            />
                            <HMSelectInput
                                onValueChange={(value) => {


                                    let idx = container.state.listMonth.findIndex(obj => obj.value == value);
                                    let res = null;
                                    if (idx !== -1) {
                                        res = container.state.listMonth[idx]
                                    }
                                    let resultMonth = this.getMonthChartValue(value);
                                    let resultSubjectList10 = this.state.listSubjectList10?.find(k => k.month.search('-' + resultMonth) >= 0);
                                    // let resultSubjectList4 = this.state.listSubjectList4?.find(k => k.month.search('-' + resultMonth) >= 0);
                                    this.setState({
                                            SelectMonthValue10: value,
                                            Month10: res ? {
                                                ...res,
                                                index: idx
                                            } : {
                                                label: "یک مورد را انتخاب نمایید ...",
                                                value: idx,
                                                index: idx
                                            }
                                        },

                                        () => {
                                            this.setState({
                                                SubjectList10: resultSubjectList10?.subjects,
                                                //SubjectList4: resultSubjectList4?.subjects,


                                            })

                                        }
                                    )
                                }}
                                // error={this.state.errorSelectInput}
                                //
                                // //  requestServerRetry={container.getServerTypeDocuments}
                                // requestServer={() => {
                                // }}
                                // value={SelectMonthValue ? "" : "یک مورد را انتخاب نمایید ..."}
                                value={SelectMonthValue10 !== null ? SelectMonthValue10 : i18n.t('constant.SelectItem')}

                                defaultValue={"یک مورد را انتخاب نمایید ..."}
                                index={Month10 ? Month10.index : -1}
                                itemSelectInput={Month10}
                                options={listMonth}

                                styleRoot={[{
                                    //width: '100%',
                                    margin: moderateScale(8),
                                    marginTop: moderateScale(14)
                                    //    height: '100%'
                                }, Platform.OS === "web" ? {} : {width: moderateScale(140),}]}
                            />
                        </View>

                        <View
                            style={{
                                width: "100%",
                                /// flex:1,
                                flexDirection: 'row',

                                marginTop: moderateScale(2),
                                // marginEnd: moderateScale(Platform.OS == "web" ? 10 : 0)
                                //  paddingEnd: moderateScale((Platform.OS === "web" && !(isMobile)) ? moderateScale(12) : 0),
                                // alignSelf: 'center'
                                // marginVertical:moderateScale(6),
                            }}>
                            <View
                                style={{
                                    width: '100%',
                                    /// flex:1,
                                    flexDirection: 'row',
                                    backgroundColor: "#174C72",
                                    marginTop: moderateScale(2),
                                    // marginEnd: moderateScale(Platform.OS == "web" ? 10 : 0)
                                    // paddingEnd: moderateScale(Platform.OS === "web" && !(navigator.userAgentData && navigator.userAgentData.mobile) ? 18 : 0),
                                    // marginEnd: moderateScale(Platform.OS == "web" ? 10 : 0)

                                    // alignSelf: 'center'
                                    // marginVertical:moderateScale(6),
                                }}>
                                <View style={{
                                    flex: .4,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginVertical: moderateScale(2),
                                    //paddingHorizontal:moderateScale(4)

                                }}>
                                    <HMTextView
                                        // numberOfLines={2}
                                        type={"bold"}
                                        text={"موضوع"}
                                        style={{
                                            fontSize: moderateScale(13),

                                            color: Colors.white
                                            //  marginTop: moderateScale(4),
                                            //  textAlign: "right",
                                        }}/>
                                </View>
                                <View style={{
                                    height: '100%',
                                    width: moderateScale(1),
                                    alignSelf: 'center',
                                    backgroundColor: Colors.colorDark
                                }}/>

                                <View style={{
                                    flex: .15,
                                    //flexDirection: "row",
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <HMTextView
                                        // numberOfLines={2}
                                        type={"bold"}
                                        text={"تعداد"}
                                        style={{
                                            fontSize: moderateScale(13),

                                            color: Colors.white,
                                            //  marginTop: moderateScale(4),
                                            textAlign: "center",

                                        }}/>

                                    <HMIcon
                                        type={"MaterialCommunityIcons"}

                                        name={(this.state.typeSort === "count" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                        style={{
                                            color: (this.state.typeSort === "count") ? "#ffffff" : "#ffffff",
                                            fontSize: moderateScale(28),
                                            //  padding: moderateScale(4),
                                            alignSelf: "center",
                                        }}
                                        onPress={() => {
                                            let Sort = (this.state.typeSort === "count" && this.state.typeOrder === "desc") ? "asc" : "desc";
                                            this.setState({
                                                    typeOrder: Sort,
                                                    typeSort: "count",

                                                },
                                                () => {
                                                    let res = Tools.getSortList(this.state.SubjectList10, "total_count", "total_count", Sort);
                                                    this.setState({
                                                        SubjectList10: res,
                                                        alaki: !this.state.alaki
                                                    })
                                                }
                                            )
                                        }}

                                    />
                                </View>
                                <View style={{
                                    height: '100%',
                                    width: moderateScale(1),
                                    alignSelf: 'center',
                                    backgroundColor: Colors.colorDark
                                }}/>
                                <View
                                    style={{
                                        flex: .15,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                    <HMTextView
                                        // numberOfLines={2}
                                        type={"bold"}
                                        text={"دردست اقدام"}
                                        style={{
                                            fontSize: moderateScale(13),

                                            color: Colors.white,
                                            //  marginTop: moderateScale(4),
                                            textAlign: "center",
                                        }}/>
                                    <HMIcon
                                        type={"MaterialCommunityIcons"}

                                        name={(this.state.typeSort === "doing" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                        style={{
                                            color: (this.state.typeSort === "doing") ? "#ffffff" : "#ffffff",
                                            fontSize: moderateScale(28),
                                            //  padding: moderateScale(4),
                                            alignSelf: "center",
                                        }}
                                        onPress={() => {
                                            let Sort = (this.state.typeSort === "doing" && this.state.typeOrder === "desc") ? "asc" : "desc";

                                            this.setState({
                                                    typeOrder: Sort,
                                                    typeSort: "doing",

                                                },
                                                () => {
                                                    let res = Tools.getSortList(this.state.SubjectList10, "inprogress_percentage", "inprogress_percentage", Sort);
                                                    this.setState({
                                                        SubjectList10: res,
                                                        alaki: !this.state.alaki
                                                    })
                                                }
                                            )
                                        }}

                                    />
                                </View>

                                <View
                                    style={{
                                        height: '100%',
                                        width: moderateScale(1),
                                        alignSelf: 'center',
                                        backgroundColor: Colors.colorDark
                                    }}/>
                                <View
                                    style={{
                                        flex: .15,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}

                                >
                                    <View

                                        onPress={() => {
                                            this.setState({
                                                resultModal: this.props.resultsAll.done,
                                                visibleModal: "Details"
                                            })

                                        }}
                                    >
                                        <HMTextView
                                            // numberOfLines={2}
                                            type={"bold"}
                                            text={"انجام شده ها"}
                                            style={[{
                                                fontSize: moderateScale(13),

                                                color: Colors.white,
                                                //  marginTop: moderateScale(4),
                                                // textAlign: "center",
                                                // textDecorationLine: "underline",
                                                // textDecorationStyle: "solid",
                                                // textDecorationColor: "#000"
                                            }
                                            ]}/>
                                    </View>
                                    <HMIcon
                                        type={"MaterialCommunityIcons"}

                                        name={(this.state.typeSort === "done" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                        style={{
                                            color: (this.state.typeSort === "done") ? "#ffffff" : "#ffffff",
                                            fontSize: moderateScale(28),
                                            //  padding: moderateScale(4),
                                            alignSelf: "center",
                                        }}
                                        onPress={() => {
                                            let Sort = (this.state.typeSort === "done" && this.state.typeOrder === "desc") ? "asc" : "desc";
                                            this.setState({
                                                    typeOrder: Sort,
                                                    typeSort: "done",

                                                },
                                                () => {
                                                    let res = Tools.getSortList(this.state.SubjectList10, "done_percentage", "done_percentage", Sort);
                                                    this.setState({
                                                        SubjectList10: res,
                                                        alaki: !this.state.alaki
                                                    })
                                                    // this.getData(1)
                                                }
                                            )
                                        }}

                                    />
                                </View>
                                <View
                                    style={{
                                        height: '100%',
                                        width: moderateScale(1),
                                        alignSelf: 'center',
                                        backgroundColor: Colors.colorDark
                                    }}/>
                                <View
                                    style={{
                                        flex: .15,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}

                                >
                                    <View
                                        onPress={() => {
                                            this.setState({
                                                resultModal: this.props.resultsAll.others,
                                                visibleModal: "Details"
                                            })

                                        }}
                                    >
                                        <HMTextView
                                            // numberOfLines={2}
                                            type={"bold"}
                                            text={"سایر"}
                                            style={{
                                                fontSize: moderateScale(13),

                                                color: Colors.white,
                                                //  marginTop: moderateScale(4),
                                                // textAlign: "center",
                                                // textDecorationLine: "underline",
                                                // textDecorationStyle: "solid",
                                                // textDecorationColor: "#000"
                                            }}/>
                                    </View>
                                    <HMIcon
                                        type={"MaterialCommunityIcons"}

                                        name={(this.state.typeSort === "other" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                        style={{
                                            color: (this.state.typeSort === "other") ? "#ffffff" : "#ffffff",
                                            fontSize: moderateScale(28),
                                            //  padding: moderateScale(4),
                                            alignSelf: "center",
                                        }}
                                        onPress={() => {
                                            let Sort = (this.state.typeSort === "other" && this.state.typeOrder === "desc") ? "asc" : "desc";
                                            this.setState({
                                                    typeOrder: Sort,
                                                    typeSort: "other",

                                                },
                                                () => {
                                                    let res = Tools.getSortList(this.state.SubjectList10, "other_percentage", "other_percentage", Sort);
                                                    this.setState({
                                                        SubjectList10: res,
                                                        alaki: !this.state.alaki
                                                    })
                                                }
                                            )
                                        }}

                                    />
                                </View>


                            </View>

                        </View>
                        <View
                            style={{
                                flex: 1,
                                //alignItems: "center",
                            }}>


                            {
                                this.state.SubjectList10 ?
                                    <HMFlatList
                                        ref={(ref) => {
                                            this.list1 = ref && ref.flatListRef?.current;
                                        }}
                                        keyExtractor={(item, index) => index.toString() + item.subject_name}
                                        // keyExtractor={(item, index) => index.toString() + (Place.top_subject_groups?.length)}
                                        extraData={{
                                            alaki: this.state.alaki,
                                            //  item: this.state.SubjectList10,
                                        }}
                                        data={this.state.SubjectList10 ? this.state.SubjectList10 : []}
                                        renderItem={({item, index}) => {
                                            let mode = true
                                            // if (Platform.OS !== "web") {
                                            //     item = type.item;
                                            //     index = type.index;
                                            // }
                                            //if (index === 0)
                                            return <View
                                                style={{
                                                    width: "100%",
                                                    // flex: 1,
                                                    overflow: 'hidden',
                                                    //    height: HeightItem,
                                                    // padding: moderateScale(4),
                                                    //  margin:moderateScale(5),
                                                    borderWidth: moderateScale(1),
                                                    // borderRadius: moderateScale(2),
                                                    borderColor: '#ddd',
                                                    // borderBottomWidth: 0,
                                                    // shadowColor: '#000',
                                                    // shadowOffset: {width: 0, height: moderateScale(.7)},
                                                    // shadowOpacity: 0.6,
                                                    // shadowRadius: moderateScale(2),
                                                    elevation: moderateScale(1),
                                                    // marginLeft: moderateScale(1),
                                                    // marginRight: moderateScale(1),
                                                    // marginTop: moderateScale(1),
                                                    // marginBottom: moderateScale(1),
                                                    backgroundColor: Colors.white,
                                                }}>
                                                <View
                                                    style={{
                                                        width: '100%',
                                                        flexDirection: 'row',
                                                        backgroundColor: Colors.white,


                                                        // alignSelf: 'center'
                                                        // marginVertical:moderateScale(6),
                                                    }}>


                                                    <View
                                                        style={{
                                                            flex: .4,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(8),
                                                            //  paddingHorizontal: moderateScale(4)
                                                        }}

                                                    >
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={item.name ? item.name : item.subject_name}
                                                            style={{
                                                                fontSize: moderateScale(13),

                                                                color: Colors.blue,
                                                                // textDecorationLine: "underline",
                                                                // textDecorationStyle: "solid",
                                                                //  marginTop: moderateScale(4),
                                                                //  textAlign: "right",
                                                            }}/>
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>

                                                    <CustomView
                                                        style={{
                                                            flex: .15,
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                        activeOpacity={mode ? .2 : 1}

                                                    >
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={item.count ? item.count : item.total_count}
                                                            style={[{
                                                                fontSize: moderateScale(14),


                                                                //  marginTop: moderateScale(4),
                                                                textAlign: "center",


                                                            }, mode ? {
                                                                color: Colors.blackLight,
                                                                // textDecorationLine: "underline",
                                                                // textDecorationStyle: "solid",
                                                            } : {color: Colors.blackLight,}]}/>
                                                    </CustomView>

                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View
                                                        style={{
                                                            flex: .15,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(2)
                                                        }}>

                                                        <CustomView
                                                            style={{
                                                                flex: .15,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                            activeOpacity={mode ? .2 : 1}

                                                        >

                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                //text={(((item.doing ? item.doing : item.inprogress_count) / (item.count ? item.count : item.total_count)) * 100) + "%"}
                                                                // text={Tools.getPercentage((item.doing ? item.doing : item.inprogress_count), (item.count ? item.count : item.total_count)) + "%"}
                                                                text={item.inprogress_percentage + "%"}
                                                                style={[{
                                                                    fontSize: moderateScale(14),


                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",


                                                                }, mode ? {
                                                                    color: Colors.blackLight,
                                                                    // textDecorationLine: "underline",
                                                                    // textDecorationStyle: "solid",
                                                                } : {color: Colors.blackLight,}]}/>
                                                        </CustomView>

                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View
                                                        style={{
                                                            flex: .15,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(2)
                                                        }}>
                                                        <CustomView
                                                            style={{
                                                                flex: .15,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                            activeOpacity={mode ? .2 : 1}

                                                        >

                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                //   text={(item.done ? item.done : item.done_count) + "%"}
                                                                //   text={Tools.getPercentage((item.done ? item.done : item.done_count), (item.count ? item.count : item.total_count)) + "%"}
                                                                text={item.done_percentage + "%"}

                                                                style={[{
                                                                    fontSize: moderateScale(14),


                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",


                                                                }, mode ? {
                                                                    color: Colors.blackLight,
                                                                    // textDecorationLine: "underline",
                                                                    // textDecorationStyle: "solid",
                                                                } : {color: Colors.blackLight,}]}/>
                                                        </CustomView>

                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View
                                                        style={{
                                                            flex: .15,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(2)
                                                        }}>
                                                        <CustomView
                                                            style={{
                                                                flex: .15,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                            activeOpacity={mode ? .2 : 1}

                                                        >

                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                //    text={(item.other ? item.other : item.other_count) + "%"}
                                                                //text={Tools.getPercentage((item.other ? item.other : item.other_count), (item.count ? item.count : item.total_count)) + "%"}
                                                                text={item.other_percentage + "%"}

                                                                style={[{
                                                                    fontSize: moderateScale(14),


                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",


                                                                }, mode ? {
                                                                    color: Colors.blackLight,
                                                                    // textDecorationLine: "underline",
                                                                    // textDecorationStyle: "solid",
                                                                } : {color: Colors.blackLight,}]}/>
                                                        </CustomView>

                                                    </View>
                                                </View>

                                            </View>
                                        }}

                                    />
                                    :
                                    null
                            }


                        </View>
                    </View>;
                case 7:
                    return null;
                default :
                    return null

            }
        }

        // let WidthChart = viewportWidth;

        //  let item = _params && _params.item ? JSON.parse(_params.item) : null;
        return (


            <View style={{position: 'relative', flex: 1}}>


                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{flex: 1,}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>
                        {/*  <HMGradient
                            style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                left: 0,
                                bottom: 0,
                                flex: 1,
                                // alignItems: 'center'
                            }}
                            color1={"#4cee1c"}
                            color2={"#0012ee"}

                            x1="0%" y1="0%" x2="0%" y2="100%"

                        />*/}

                        <HMActionBar
                            //  menu={!checkLogin}
                            menu={typeExport._NameApp != "MahalemaArak"}
                            // menu
                            back={typeExport._NameApp != "MahalemaArak"}
                            //  exit={checkLogin && !type}
                            exit={typeExport._NameApp == "MahalemaArak"}
                            funcExit={() => {

                                HMAlert(
                                    i18n.t('constant.message'),
                                    "آیا می خواهید از حساب کاربری خود خارج شوید؟",
                                    [
                                        // {text: 'Ask me later', onPress: () => {}},
                                        // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                        {
                                            text: i18n.t('constant.ok'), onPress: () => {
                                                AsyngStorageClass.removeToken(typeExport._Shahrdar);
                                                NavigationService.resetTo('LoginStackScreen');

                                            }
                                        },
                                    ],
                                    {cancelable: true}
                                )


                                // Tools.remove()
                                // NavigationService.resetTo("SplashScreen")
                            }}
                            props={this.props} statusBarTransparent
                            //  text={i18n.t('Apply.title')}
                            // text={item ? (item.name ? item.name : (item.title ? item.title : '')) : checkLogin && this.props.DataSplashScreen.user ? this.props.DataSplashScreen.user.name + " " + this.props.DataSplashScreen.user.family : null}
                            text={item ? (item.name ? item.name : (item.title ? item.title : 'داشبورد عملکرد')) : "داشبورد عملکرد"}
                            //  text={i18n.t('constant.Information')}

                            headerVisibility more_menu
                            onBackPress={() => this.props.navigation.pop()}
                            // funcExit={checkLogin ? () => {
                            //
                            //     HMAlert(
                            //         i18n.t('constant.message'),
                            //         "آیا می خواهید از حساب کاربری خود خارج شوید؟",
                            //         [
                            //             // {text: 'Ask me later', onPress: () => {}},
                            //             // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                            //             {
                            //                 text: i18n.t('constant.ok'), onPress: () => {
                            //                     AsyngStorageClass.removeToken(typeExport._Shahrdar);
                            //                 }
                            //             },
                            //         ],
                            //         {cancelable: true}
                            //     )
                            //
                            //
                            //     // Tools.remove()
                            //     // NavigationService.resetTo("SplashScreen")
                            // } : null}
                            styleText={[{marginStart: moderateScale(48)}]}

                        />
                        <HMSelectInput
                            onValueChange={(value) => {


                                let idx = container.state.listPlace.findIndex(obj => obj.value == value);
                                let res = null;
                                if (idx !== -1) {
                                    res = container.state.listPlace[idx]
                                }

                                this.setState({
                                        SelectPlaceValue: value,
                                        Place: res ? {
                                            ...res,
                                            index: idx
                                        } : {
                                            label: "یک مورد را انتخاب نمایید ...",
                                            value: idx,
                                            index: idx
                                        }
                                    },

                                    () => {
                                        this.convertDataChart();

                                    }
                                )
                            }}
                            // error={this.state.errorSelectInput}
                            //
                            // //  requestServerRetry={container.getServerTypeDocuments}
                            // requestServer={() => {
                            // }}
                            // value={SelectPlaceValue ? "" : "یک مورد را انتخاب نمایید ..."}
                            value={SelectPlaceValue !== null ? SelectPlaceValue : i18n.t('constant.SelectItem')}

                            defaultValue={"یک مورد را انتخاب نمایید ..."}
                            index={Place ? Place.index : -1}
                            itemSelectInput={Place}
                            options={listPlace}

                            styleRoot={{
                                //width: '100%',
                                margin: moderateScale(8)
                                //    height: '100%'
                            }}
                        />
                        {
                            (!this.props.DataSplashScreen.NoInternetDialogShahrdar) && (!this.props.DataSplashScreen.isLoadingShahrdar) ?
                                null
                                :
                                <View
                                    style={{
                                        width: "100%",
                                        //  flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: this.props.DataSplashScreen.NoInternetDialogShahrdar ? Colors.red : Colors.white,
                                        alignSelf: 'center',
                                        padding: moderateScale(6)
                                    }}
                                >
                                    {this.props.DataSplashScreen.NoInternetDialogShahrdar ?
                                        <View
                                            style={{
                                                width: "100%",
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',

                                            }}>


                                            <HMTextView
                                                type={"bold"}

                                                style={[
                                                    {
                                                        // position: 'absolute',
                                                        //  bottom: 0,
                                                        // height: moderateScale(44),
                                                        // width: '100%',
                                                        textAlign: "center",
                                                        color: Colors.white,
                                                        fontSize: moderateScale(11),
                                                        //  padding: moderateScale(1),

                                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                                    }]}
                                                numberOfLines={2}
                                                text={"خطایی رخ داده مجددا تلاش نمایید"}
                                            />
                                            <View style={{width: moderateScale(4)}}/>
                                            <TouchableOpacity
                                                onPress={() => {
                                                    this.getDataServerSplash()

                                                }}
                                                style={{
                                                    // flex: .33,
                                                    // width: '92%',
                                                    // height: moderateScale(28),
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor: Colors.yellow,
                                                    borderRadius: moderateScale(6),
                                                    marginHorizontal: moderateScale(2),
                                                    paddingHorizontal: moderateScale(4),
                                                    paddingVertical: moderateScale(2),


                                                }}>

                                                <HMTextView
                                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                    text={i18n.t('constant.Update')}
                                                    //  text={"ثبت و بستن تیکت"}
                                                    type={"bold"}
                                                    style={{
                                                        fontSize: moderateScale(10),
                                                        marginVertical: moderateScale(2),
                                                        //     marginHorizontal: moderateScale(4),
                                                        color: Colors.white
                                                    }}/>
                                            </TouchableOpacity>

                                        </View>
                                        :

                                        <View
                                            style={{
                                                width: "100%",
                                                flexDirection: 'row',
                                                justifyContent: 'center',
                                                alignItems: 'center',

                                            }}>


                                            <HMTextView
                                                type={"bold"}

                                                style={[
                                                    {
                                                        // position: 'absolute',
                                                        //  bottom: 0,
                                                        // height: moderateScale(44),
                                                        // width: '100%',
                                                        textAlign: "center",
                                                        color: Colors.colorDark,
                                                        fontSize: moderateScale(11),
                                                        //  padding: moderateScale(1),

                                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                                    }]}
                                                numberOfLines={2}
                                                text={i18n.t('constant.Update')}
                                            />
                                            <View style={{width: moderateScale(4)}}/>
                                            <ActivityIndicator color={Colors.colorPrimary} size={"small"}/>

                                        </View>
                                    }
                                </View>


                        }

                        {
                            this.props.results == null && this.props.isLoading ?
                                <HMLoading/>

                                :

                                <View
                                    style={{
                                        //  width: viewportWidth,
                                        //  width: viewportWidth,
                                        flex: 1,
                                        //width: "100%",
                                        // alignItems: 'center'
                                    }}
                                >
                                    <ScrollView
                                        contentContainerStyle={{flexGrow: 1, justifyContent: 'center'}}
                                    >

                                        <View style={{
                                            flex: 1,
                                            flexWrap: "wrap",
                                            flexDirection: "row",
                                            justifyContent: "center",
                                        }}>
                                            {
                                                widgets?.map((dataWidget, indexWidget) => {
                                                    return renderWidgets(dataWidget)
                                                })
                                            }
                                        </View>

                                        {/*

                                        <View
                                            style={{
                                                flex: 1,
                                                // width: "100%",
                                                //  height: "100%",
                                                //  height: viewportHeight,

                                                //  backgroundColor:"#0500ee",

                                            }}>

                                            <View
                                                style={{
                                                    flex: 1,
                                                    flexWrap: "wrap",
                                                    // width: "100%",
                                                    flexDirection: !(smallView) ? "row" : "column"
                                                }}>
                                                <View
                                                    style={{
                                                        flex: !smallView ? .5 : 1,
                                                        minHeight: moderateScale(240),

                                                        // width: viewportWidth/(!smallView ? 2 : 1),
                                                        //  height: moderateScale(700) / 2,
                                                        // width: viewportWidth/(!smallView ? 2 : 1),
                                                        // height: viewportWidth/(!smallView ? 4 : 2),
                                                        overflow: "hidden",
                                                        /// backgroundColor: "#1f00ee",


                                                    }}>
                                                    {
                                                        this.state.dataChart ?
                                                            <HMLineChart
                                                                dataChart={this.state.dataChart}
                                                                title={"درصد رضایت کسب شده در مقایسه با مناطق"}
                                                            />
                                                            :
                                                            null
                                                    }

                                                </View>
                                                <View
                                                    style={{
                                                        flex: !smallView ? .5 : 1,
                                                        minHeight: moderateScale(450),

                                                        //  width: viewportWidth/(!smallView ? 2 : 1),
                                                        //  height: viewportWidth/(!smallView ? 4 : 2),

                                                        //  height: moderateScale(700) / 2,

                                                        overflow: "hidden",
                                                        /// backgroundColor: "#1f00ee",


                                                    }}>
                                                    {
                                                        this.state.dataChart2 ?
                                                            <HMLineChart
                                                                dataChart={this.state.dataChart2}
                                                                title={"درصد رضایت کسب شده"}

                                                            />
                                                            :
                                                            null
                                                    }

                                                </View>

                                            </View>

                                            <View
                                                style={{
                                                    flex: 1,
                                                    flexWrap: "wrap",

                                                    flexDirection: !(smallView) ? "row" : "column"
                                                }}>

                                                <View
                                                    style={{
                                                        // width: viewportWidth/(!smallView ? 2 : 1),

                                                        flex: !smallView ? .5 : 1,
                                                        minHeight: moderateScale(240),

                                                        //height: moderateScale(700) / 2,

                                                        overflow: "hidden",
                                                        //  backgroundColor: "#1f00ee",

                                                    }}>
                                                    {
                                                        this.state.dataChartGroupBarChart ?

                                                            <HMGroupBarChart
                                                                dataChart={this.state.dataChartGroupBarChart}
                                                                item={[]}
                                                                title={"درصد امتیاز کسب شده در مقایسه با مناطق"}
                                                            />
                                                            :
                                                            null
                                                    }

                                                </View>
                                                <View
                                                    style={{
                                                        // width: viewportWidth/(!smallView ? 2 : 1),

                                                        flex: !smallView ? .5 : 1,
                                                        minHeight: moderateScale(450),
                                                        //height: moderateScale(700) / 2,

                                                        overflow: "hidden",
                                                        //  backgroundColor: "#1f00ee",

                                                    }}>
                                                    {
                                                        this.state.dataChart3 ?
                                                            <HMLineChart
                                                                dataChart={this.state.dataChart3}
                                                                title={"درصد رضایت کسب شده"}
                                                            />
                                                            :
                                                            null
                                                    }


                                                </View>
                                            </View>

                                            <HMSelectInput
                                                onValueChange={(value) => {


                                                    let idx = container.state.listMonth.findIndex(obj => obj.value == value);
                                                    let res = null;
                                                    if (idx !== -1) {
                                                        res = container.state.listMonth[idx]
                                                    }
                                                    let resultMonth = this.getMonthChartValue(value);
                                                    let resultSubjectList10 = this.state.listSubjectList10?.find(k => k.month.search('-' + resultMonth) >= 0);
                                                    let resultSubjectList4 = this.state.listSubjectList4?.find(k => k.month.search('-' + resultMonth) >= 0);
                                                    this.setState({
                                                            SelectMonthValue: value,
                                                            Month: res ? {
                                                                ...res,
                                                                index: idx
                                                            } : {
                                                                label: "یک مورد را انتخاب نمایید ...",
                                                                value: idx,
                                                                index: idx
                                                            }
                                                        },

                                                        () => {
                                                            this.setState({
                                                                SubjectList10: resultSubjectList10?.subjects,
                                                                SubjectList4: resultSubjectList4?.subjects,


                                                            })

                                                        }
                                                    )
                                                }}
                                                // error={this.state.errorSelectInput}
                                                //
                                                // //  requestServerRetry={container.getServerTypeDocuments}
                                                // requestServer={() => {
                                                // }}
                                                // value={SelectMonthValue ? "" : "یک مورد را انتخاب نمایید ..."}
                                                value={SelectMonthValue !== null ? SelectMonthValue : i18n.t('constant.SelectItem')}

                                                defaultValue={"یک مورد را انتخاب نمایید ..."}
                                                index={Month ? Month.index : -1}
                                                itemSelectInput={Month}
                                                options={listMonth}

                                                styleRoot={{
                                                    //width: '100%',
                                                    margin: moderateScale(8),
                                                    marginTop: moderateScale(14)
                                                    //    height: '100%'
                                                }}
                                            />
                                            <View
                                                style={{
                                                    width: "100%",

                                                    marginBottom: moderateScale(14)
                                                }}>

                                                <View style={{}}>
                                                    <HMTextView
                                                        // numberOfLines={2}
                                                        type={"bold"}
                                                        text={"4 گروه موضوع اصلی " + Place?.name}
                                                        style={{
                                                            fontSize: moderateScale(16),

                                                            color: Colors.blackLight,


                                                            // textDecorationColor: "#000"
                                                        }}
                                                        styleRoot={{alignSelf: "center"}}
                                                    />

                                                </View>
                                                <View
                                                    style={{
                                                        width: "100%",
                                                        /// flex:1,
                                                        flexDirection: 'row',

                                                        marginTop: moderateScale(2),

                                                    }}>
                                                    <View
                                                        style={{
                                                            width: '100%',
                                                            /// flex:1,
                                                            flexDirection: 'row',
                                                            backgroundColor: "#174C72",
                                                            marginTop: moderateScale(2),

                                                        }}>
                                                        <View style={{
                                                            flex: .4,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(2),
                                                            //paddingHorizontal:moderateScale(4)

                                                        }}>
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={"موضوع"}
                                                                style={{
                                                                    fontSize: moderateScale(13),

                                                                    color: Colors.white
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",
                                                                }}/>
                                                        </View>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(1),
                                                            alignSelf: 'center',
                                                            backgroundColor: Colors.colorDark
                                                        }}/>

                                                        <View style={{
                                                            flex: .15,
                                                            //flexDirection: "row",
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}>
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={"تعداد"}
                                                                style={{
                                                                    fontSize: moderateScale(13),

                                                                    color: Colors.white,
                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",

                                                                }}/>

                                                            <HMIcon
                                                                type={"MaterialCommunityIcons"}

                                                                name={(this.state.typeSort === "count" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                                                style={{
                                                                    color: (this.state.typeSort === "count") ? "#ffffff" : "#ffffff",
                                                                    fontSize: moderateScale(28),
                                                                    //  padding: moderateScale(4),
                                                                    alignSelf: "center",
                                                                }}
                                                                onPress={() => {
                                                                    let Sort = (this.state.typeSort === "count" && this.state.typeOrder === "desc") ? "asc" : "desc";
                                                                    this.setState({
                                                                            typeOrder: Sort,
                                                                            typeSort: "count",

                                                                        },
                                                                        () => {
                                                                            let res = Tools.getSortList(this.state.SubjectList4, "total_count", "total_count", Sort);
                                                                            this.setState({
                                                                                SubjectList4: res,
                                                                                alaki: !this.state.alaki
                                                                            })
                                                                        }
                                                                    )
                                                                }}

                                                            />
                                                        </View>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(1),
                                                            alignSelf: 'center',
                                                            backgroundColor: Colors.colorDark
                                                        }}/>
                                                        <View
                                                            style={{
                                                                flex: .15,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}>
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={"دردست اقدام"}
                                                                style={{
                                                                    fontSize: moderateScale(13),

                                                                    color: Colors.white,
                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",
                                                                }}/>
                                                            <HMIcon
                                                                type={"MaterialCommunityIcons"}

                                                                name={(this.state.typeSort === "doing" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                                                style={{
                                                                    color: (this.state.typeSort === "doing") ? "#ffffff" : "#ffffff",
                                                                    fontSize: moderateScale(28),
                                                                    //  padding: moderateScale(4),
                                                                    alignSelf: "center",
                                                                }}
                                                                onPress={() => {
                                                                    let Sort = (this.state.typeSort === "doing" && this.state.typeOrder === "desc") ? "asc" : "desc";

                                                                    this.setState({
                                                                            typeOrder: Sort,
                                                                            typeSort: "doing",

                                                                        },
                                                                        () => {
                                                                            let res = Tools.getSortList(this.state.SubjectList4, "inprogress_count", "inprogress_count", Sort);
                                                                            this.setState({
                                                                                SubjectList4: res,
                                                                                alaki: !this.state.alaki
                                                                            })
                                                                        }
                                                                    )
                                                                }}

                                                            />
                                                        </View>

                                                        <View
                                                            style={{
                                                                height: '100%',
                                                                width: moderateScale(1),
                                                                alignSelf: 'center',
                                                                backgroundColor: Colors.colorDark
                                                            }}/>
                                                        <View
                                                            style={{
                                                                flex: .15,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}

                                                        >
                                                            <View

                                                                onPress={() => {
                                                                    this.setState({
                                                                        resultModal: this.props.resultsAll.done,
                                                                        visibleModal: "Details"
                                                                    })
                                                                }}
                                                            >
                                                                <HMTextView
                                                                    // numberOfLines={2}
                                                                    type={"bold"}
                                                                    text={"انجام شده ها"}
                                                                    style={[{
                                                                        fontSize: moderateScale(13),

                                                                        color: Colors.white,
                                                                        //  marginTop: moderateScale(4),
                                                                        // textAlign: "center",
                                                                        // textDecorationLine: "underline",
                                                                        // textDecorationStyle: "solid",
                                                                        // textDecorationColor: "#000"
                                                                    }
                                                                    ]}/>
                                                            </View>
                                                            <HMIcon
                                                                type={"MaterialCommunityIcons"}

                                                                name={(this.state.typeSort === "done" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                                                style={{
                                                                    color: (this.state.typeSort === "done") ? "#ffffff" : "#ffffff",
                                                                    fontSize: moderateScale(28),
                                                                    //  padding: moderateScale(4),
                                                                    alignSelf: "center",
                                                                }}
                                                                onPress={() => {
                                                                    let Sort = (this.state.typeSort === "done" && this.state.typeOrder === "desc") ? "asc" : "desc";
                                                                    this.setState({
                                                                            typeOrder: Sort,
                                                                            typeSort: "done",

                                                                        },
                                                                        () => {
                                                                            let res = Tools.getSortList(this.state.SubjectList4, "done_count", "done_count", Sort);
                                                                            this.setState({
                                                                                SubjectList4: res,
                                                                                alaki: !this.state.alaki
                                                                            })
                                                                            // this.getData(1)
                                                                        }
                                                                    )
                                                                }}

                                                            />
                                                        </View>
                                                        <View
                                                            style={{
                                                                height: '100%',
                                                                width: moderateScale(1),
                                                                alignSelf: 'center',
                                                                backgroundColor: Colors.colorDark
                                                            }}/>
                                                        <View
                                                            style={{
                                                                flex: .15,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}

                                                        >
                                                            <View
                                                                onPress={() => {
                                                                    this.setState({
                                                                        resultModal: this.props.resultsAll.others,
                                                                        visibleModal: "Details"
                                                                    })

                                                                }}
                                                            >
                                                                <HMTextView
                                                                    // numberOfLines={2}
                                                                    type={"bold"}
                                                                    text={"سایر"}
                                                                    style={{
                                                                        fontSize: moderateScale(13),

                                                                        color: Colors.white,
                                                                        //  marginTop: moderateScale(4),
                                                                        // textAlign: "center",
                                                                        // textDecorationLine: "underline",
                                                                        // textDecorationStyle: "solid",
                                                                        // textDecorationColor: "#000"
                                                                    }}/>
                                                            </View>
                                                            <HMIcon
                                                                type={"MaterialCommunityIcons"}

                                                                name={(this.state.typeSort === "other" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                                                style={{
                                                                    color: (this.state.typeSort === "other") ? "#ffffff" : "#ffffff",
                                                                    fontSize: moderateScale(28),
                                                                    //  padding: moderateScale(4),
                                                                    alignSelf: "center",
                                                                }}
                                                                onPress={() => {
                                                                    let Sort = (this.state.typeSort === "other" && this.state.typeOrder === "desc") ? "asc" : "desc";
                                                                    this.setState({
                                                                            typeOrder: Sort,
                                                                            typeSort: "other",

                                                                        },
                                                                        () => {
                                                                            let res = Tools.getSortList(this.state.SubjectList4, "other_count", "other_count", Sort);
                                                                            this.setState({
                                                                                SubjectList4: res,
                                                                                alaki: !this.state.alaki
                                                                            })
                                                                        }
                                                                    )
                                                                }}

                                                            />
                                                        </View>


                                                    </View>

                                                </View>
                                                <View
                                                    style={{
                                                        flex: 1,
                                                        //alignItems: "center",
                                                    }}>


                                                           <EmptyView
                                                        empty={Place && Place.top_subject_groups && Place && Place.top_subject_groups.length === 0}/>

                                                    {
                                                        this.state.SubjectList4 ?
                                                            <HMFlatList
                                                                ref={(ref) => {
                                                                    this.list1 = ref && ref.flatListRef?.current;
                                                                }}
                                                                keyExtractor={(item, index) => index.toString() + item.subject_name}
                                                                // keyExtractor={(item, index) => index.toString() + (Place.top_subject_groups?.length)}
                                                                extraData={{
                                                                    alaki: this.state.alaki,
                                                                    // SubjectList4: this.state.SubjectList4,
                                                                }}
                                                                data={this.state.SubjectList4 ? this.state.SubjectList4 : []}
                                                                renderItem={({item, index}) => {
                                                                    let mode = true
                                                                    // if (Platform.OS !== "web") {
                                                                    //     item = type.item;
                                                                    //     index = type.index;
                                                                    // }
                                                                    //if (index === 0)
                                                                    return <View
                                                                        style={{
                                                                            width: "100%",
                                                                            // flex: 1,
                                                                            overflow: 'hidden',
                                                                            //    height: HeightItem,
                                                                            // padding: moderateScale(4),
                                                                            //  margin:moderateScale(5),
                                                                            borderWidth: moderateScale(1),
                                                                            // borderRadius: moderateScale(2),
                                                                            borderColor: '#ddd',
                                                                            // borderBottomWidth: 0,
                                                                            // shadowColor: '#000',
                                                                            // shadowOffset: {width: 0, height: moderateScale(.7)},
                                                                            // shadowOpacity: 0.6,
                                                                            // shadowRadius: moderateScale(2),
                                                                            elevation: moderateScale(1),
                                                                            // marginLeft: moderateScale(1),
                                                                            // marginRight: moderateScale(1),
                                                                            // marginTop: moderateScale(1),
                                                                            // marginBottom: moderateScale(1),
                                                                            backgroundColor: Colors.white,
                                                                        }}>
                                                                        <View
                                                                            style={{
                                                                                width: '100%',
                                                                                flexDirection: 'row',
                                                                                backgroundColor: Colors.white,


                                                                                // alignSelf: 'center'
                                                                                // marginVertical:moderateScale(6),
                                                                            }}>


                                                                            <View
                                                                                style={{
                                                                                    flex: .4,
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    marginVertical: moderateScale(8),
                                                                                    //  paddingHorizontal: moderateScale(4)
                                                                                }}

                                                                            >
                                                                                <HMTextView
                                                                                    // numberOfLines={2}
                                                                                    type={"bold"}
                                                                                    text={item.name ? item.name : item.subject_name}
                                                                                    style={{
                                                                                        fontSize: moderateScale(13),

                                                                                        color: Colors.blue,
                                                                                        // textDecorationLine: "underline",
                                                                                        // textDecorationStyle: "solid",
                                                                                        //  marginTop: moderateScale(4),
                                                                                        //  textAlign: "right",
                                                                                    }}/>
                                                                            </View>
                                                                            <View style={{
                                                                                height: '100%',
                                                                                width: moderateScale(1),
                                                                                alignSelf: 'center',
                                                                                backgroundColor: Colors.light43
                                                                            }}/>

                                                                            <CustomView
                                                                                style={{
                                                                                    flex: .15,
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center'
                                                                                }}
                                                                                activeOpacity={mode ? .2 : 1}

                                                                            >
                                                                                <HMTextView
                                                                                    // numberOfLines={2}
                                                                                    type={"bold"}
                                                                                    text={item.count ? item.count : item.total_count}
                                                                                    style={[{
                                                                                        fontSize: moderateScale(14),


                                                                                        //  marginTop: moderateScale(4),
                                                                                        textAlign: "center",


                                                                                    }, mode ? {
                                                                                        color: Colors.blackLight,
                                                                                        // textDecorationLine: "underline",
                                                                                        // textDecorationStyle: "solid",
                                                                                    } : {color: Colors.blackLight,}]}/>
                                                                            </CustomView>

                                                                            <View style={{
                                                                                height: '100%',
                                                                                width: moderateScale(1),
                                                                                alignSelf: 'center',
                                                                                backgroundColor: Colors.light43
                                                                            }}/>
                                                                            <View
                                                                                style={{
                                                                                    flex: .15,
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    marginVertical: moderateScale(2)
                                                                                }}>

                                                                                <CustomView
                                                                                    style={{
                                                                                        flex: .15,
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center'
                                                                                    }}
                                                                                    activeOpacity={mode ? .2 : 1}

                                                                                >

                                                                                    <HMTextView
                                                                                        // numberOfLines={2}
                                                                                        type={"bold"}
                                                                                        //text={(((item.doing ? item.doing : item.inprogress_count) / (item.count ? item.count : item.total_count)) * 100) + "%"}
                                                                                        text={Tools.getPercentage((item.doing ? item.doing : item.inprogress_count), (item.count ? item.count : item.total_count)) + "%"}
                                                                                        style={[{
                                                                                            fontSize: moderateScale(14),


                                                                                            //  marginTop: moderateScale(4),
                                                                                            textAlign: "center",


                                                                                        }, mode ? {
                                                                                            color: Colors.blackLight,
                                                                                            // textDecorationLine: "underline",
                                                                                            // textDecorationStyle: "solid",
                                                                                        } : {color: Colors.blackLight,}]}/>
                                                                                </CustomView>

                                                                            </View>
                                                                            <View style={{
                                                                                height: '100%',
                                                                                width: moderateScale(1),
                                                                                alignSelf: 'center',
                                                                                backgroundColor: Colors.light43
                                                                            }}/>
                                                                            <View
                                                                                style={{
                                                                                    flex: .15,
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    marginVertical: moderateScale(2)
                                                                                }}>
                                                                                <CustomView
                                                                                    style={{
                                                                                        flex: .15,
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center'
                                                                                    }}
                                                                                    activeOpacity={mode ? .2 : 1}

                                                                                >

                                                                                    <HMTextView
                                                                                        // numberOfLines={2}
                                                                                        type={"bold"}
                                                                                        //   text={(item.done ? item.done : item.done_count) + "%"}
                                                                                        text={Tools.getPercentage((item.done ? item.done : item.done_count), (item.count ? item.count : item.total_count)) + "%"}

                                                                                        style={[{
                                                                                            fontSize: moderateScale(14),


                                                                                            //  marginTop: moderateScale(4),
                                                                                            textAlign: "center",


                                                                                        }, mode ? {
                                                                                            color: Colors.blackLight,
                                                                                            // textDecorationLine: "underline",
                                                                                            // textDecorationStyle: "solid",
                                                                                        } : {color: Colors.blackLight,}]}/>
                                                                                </CustomView>

                                                                            </View>
                                                                            <View style={{
                                                                                height: '100%',
                                                                                width: moderateScale(1),
                                                                                alignSelf: 'center',
                                                                                backgroundColor: Colors.light43
                                                                            }}/>
                                                                            <View
                                                                                style={{
                                                                                    flex: .15,
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    marginVertical: moderateScale(2)
                                                                                }}>
                                                                                <CustomView
                                                                                    style={{
                                                                                        flex: .15,
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center'
                                                                                    }}
                                                                                    activeOpacity={mode ? .2 : 1}

                                                                                >

                                                                                    <HMTextView
                                                                                        // numberOfLines={2}
                                                                                        type={"bold"}
                                                                                        //    text={(item.other ? item.other : item.other_count) + "%"}
                                                                                        text={Tools.getPercentage((item.other ? item.other : item.other_count), (item.count ? item.count : item.total_count)) + "%"}

                                                                                        style={[{
                                                                                            fontSize: moderateScale(14),


                                                                                            //  marginTop: moderateScale(4),
                                                                                            textAlign: "center",


                                                                                        }, mode ? {
                                                                                            color: Colors.blackLight,
                                                                                            // textDecorationLine: "underline",
                                                                                            // textDecorationStyle: "solid",
                                                                                        } : {color: Colors.blackLight,}]}/>
                                                                                </CustomView>

                                                                            </View>
                                                                        </View>

                                                                    </View>
                                                                }}

                                                            />
                                                            :
                                                            null
                                                    }


                                                </View>
                                            </View>
                                            <View
                                                style={{
                                                    width: "100%",

                                                    marginVertical: moderateScale(14)
                                                }}>
                                                <HMTextView
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    text={"10 گروه موضوع اصلی " + Place?.name}
                                                    style={{
                                                        fontSize: moderateScale(16),

                                                        color: Colors.blackLight,


                                                        // textDecorationColor: "#000"
                                                    }}
                                                    styleRoot={{alignSelf: "center"}}
                                                />
                                                <View
                                                    style={{
                                                        width: "100%",
                                                        /// flex:1,
                                                        flexDirection: 'row',

                                                        marginTop: moderateScale(2),

                                                    }}>
                                                    <View
                                                        style={{
                                                            width: '100%',
                                                            /// flex:1,
                                                            flexDirection: 'row',
                                                            backgroundColor: "#174C72",
                                                            marginTop: moderateScale(2),

                                                        }}>
                                                        <View style={{
                                                            flex: .4,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(2),
                                                            //paddingHorizontal:moderateScale(4)

                                                        }}>
                                                            <HMTextView
                                                                type={"bold"}
                                                                text={"موضوع"}
                                                                style={{
                                                                    fontSize: moderateScale(13),

                                                                    color: Colors.white
                                                                    //  marginTop: moderateScale(4),
                                                                    //  textAlign: "right",
                                                                }}/>
                                                        </View>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(1),
                                                            alignSelf: 'center',
                                                            backgroundColor: Colors.colorDark
                                                        }}/>

                                                        <View style={{
                                                            flex: .15,
                                                            //flexDirection: "row",
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}>
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={"تعداد"}
                                                                style={{
                                                                    fontSize: moderateScale(13),

                                                                    color: Colors.white,
                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",

                                                                }}/>

                                                            <HMIcon
                                                                type={"MaterialCommunityIcons"}

                                                                name={(this.state.typeSort === "count" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                                                style={{
                                                                    color: (this.state.typeSort === "count") ? "#ffffff" : "#ffffff",
                                                                    fontSize: moderateScale(28),
                                                                    //  padding: moderateScale(4),
                                                                    alignSelf: "center",
                                                                }}
                                                                onPress={() => {
                                                                    let Sort = (this.state.typeSort === "count" && this.state.typeOrder === "desc") ? "asc" : "desc";
                                                                    this.setState({
                                                                            typeOrder: Sort,
                                                                            typeSort: "count",

                                                                        },
                                                                        () => {
                                                                            let res = Tools.getSortList(this.state.SubjectList10, "total_count", "total_count", Sort);
                                                                            this.setState({
                                                                                SubjectList10: res,
                                                                                alaki: !this.state.alaki
                                                                            })
                                                                        }
                                                                    )
                                                                }}

                                                            />
                                                        </View>
                                                        <View style={{
                                                            height: '100%',
                                                            width: moderateScale(1),
                                                            alignSelf: 'center',
                                                            backgroundColor: Colors.colorDark
                                                        }}/>
                                                        <View
                                                            style={{
                                                                flex: .15,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}>
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={"دردست اقدام"}
                                                                style={{
                                                                    fontSize: moderateScale(13),

                                                                    color: Colors.white,
                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",
                                                                }}/>
                                                            <HMIcon
                                                                type={"MaterialCommunityIcons"}

                                                                name={(this.state.typeSort === "doing" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                                                style={{
                                                                    color: (this.state.typeSort === "doing") ? "#ffffff" : "#ffffff",
                                                                    fontSize: moderateScale(28),
                                                                    //  padding: moderateScale(4),
                                                                    alignSelf: "center",
                                                                }}
                                                                onPress={() => {
                                                                    let Sort = (this.state.typeSort === "doing" && this.state.typeOrder === "desc") ? "asc" : "desc";

                                                                    this.setState({
                                                                            typeOrder: Sort,
                                                                            typeSort: "doing",

                                                                        },
                                                                        () => {
                                                                            let res = Tools.getSortList(this.state.SubjectList10, "inprogress_count", "inprogress_count", Sort);
                                                                            this.setState({
                                                                                SubjectList10: res,
                                                                                alaki: !this.state.alaki
                                                                            })
                                                                        }
                                                                    )
                                                                }}

                                                            />
                                                        </View>

                                                        <View
                                                            style={{
                                                                height: '100%',
                                                                width: moderateScale(1),
                                                                alignSelf: 'center',
                                                                backgroundColor: Colors.colorDark
                                                            }}/>
                                                        <View
                                                            style={{
                                                                flex: .15,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}

                                                        >
                                                            <View

                                                                onPress={() => {
                                                                    this.setState({
                                                                        resultModal: this.props.resultsAll.done,
                                                                        visibleModal: "Details"
                                                                    })

                                                                }}
                                                            >
                                                                <HMTextView
                                                                    // numberOfLines={2}
                                                                    type={"bold"}
                                                                    text={"انجام شده ها"}
                                                                    style={[{
                                                                        fontSize: moderateScale(13),

                                                                        color: Colors.white,
                                                                    }
                                                                    ]}/>
                                                            </View>
                                                            <HMIcon
                                                                type={"MaterialCommunityIcons"}

                                                                name={(this.state.typeSort === "done" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                                                style={{
                                                                    color: (this.state.typeSort === "done") ? "#ffffff" : "#ffffff",
                                                                    fontSize: moderateScale(28),
                                                                    //  padding: moderateScale(4),
                                                                    alignSelf: "center",
                                                                }}
                                                                onPress={() => {
                                                                    let Sort = (this.state.typeSort === "done" && this.state.typeOrder === "desc") ? "asc" : "desc";
                                                                    this.setState({
                                                                            typeOrder: Sort,
                                                                            typeSort: "done",

                                                                        },
                                                                        () => {
                                                                            let res = Tools.getSortList(this.state.SubjectList10, "done_count", "done_count", Sort);
                                                                            this.setState({
                                                                                SubjectList10: res,
                                                                                alaki: !this.state.alaki
                                                                            })
                                                                            // this.getData(1)
                                                                        }
                                                                    )
                                                                }}

                                                            />
                                                        </View>
                                                        <View
                                                            style={{
                                                                height: '100%',
                                                                width: moderateScale(1),
                                                                alignSelf: 'center',
                                                                backgroundColor: Colors.colorDark
                                                            }}/>
                                                        <View
                                                            style={{
                                                                flex: .15,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}

                                                        >
                                                            <View
                                                                onPress={() => {
                                                                    this.setState({
                                                                        resultModal: this.props.resultsAll.others,
                                                                        visibleModal: "Details"
                                                                    })

                                                                }}
                                                            >
                                                                <HMTextView
                                                                    // numberOfLines={2}
                                                                    type={"bold"}
                                                                    text={"سایر"}
                                                                    style={{
                                                                        fontSize: moderateScale(13),

                                                                        color: Colors.white,

                                                                    }}/>
                                                            </View>
                                                            <HMIcon
                                                                type={"MaterialCommunityIcons"}

                                                                name={(this.state.typeSort === "other" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                                                style={{
                                                                    color: (this.state.typeSort === "other") ? "#ffffff" : "#ffffff",
                                                                    fontSize: moderateScale(28),
                                                                    //  padding: moderateScale(4),
                                                                    alignSelf: "center",
                                                                }}
                                                                onPress={() => {
                                                                    let Sort = (this.state.typeSort === "other" && this.state.typeOrder === "desc") ? "asc" : "desc";
                                                                    this.setState({
                                                                            typeOrder: Sort,
                                                                            typeSort: "other",

                                                                        },
                                                                        () => {
                                                                            let res = Tools.getSortList(this.state.SubjectList10, "other_count", "other_count", Sort);
                                                                            this.setState({
                                                                                SubjectList10: res,
                                                                                alaki: !this.state.alaki
                                                                            })
                                                                        }
                                                                    )
                                                                }}

                                                            />
                                                        </View>


                                                    </View>

                                                </View>
                                                <View
                                                    style={{
                                                        flex: 1,
                                                        //alignItems: "center",
                                                    }}>

                                                    {
                                                        this.state.SubjectList10 ?
                                                            <HMFlatList
                                                                ref={(ref) => {
                                                                    this.list1 = ref && ref.flatListRef?.current;
                                                                }}
                                                                keyExtractor={(item, index) => index.toString() + item.subject_name}
                                                                // keyExtractor={(item, index) => index.toString() + (Place.top_subject_groups?.length)}
                                                                extraData={{
                                                                    alaki: this.state.alaki,
                                                                    //  item: this.state.SubjectList10,
                                                                }}
                                                                data={this.state.SubjectList10 ? this.state.SubjectList10 : []}
                                                                renderItem={({item, index}) => {
                                                                    let mode = true
                                                                    // if (Platform.OS !== "web") {
                                                                    //     item = type.item;
                                                                    //     index = type.index;
                                                                    // }
                                                                    //if (index === 0)
                                                                    return <View
                                                                        style={{
                                                                            width: "100%",
                                                                            // flex: 1,
                                                                            overflow: 'hidden',
                                                                            //    height: HeightItem,
                                                                            // padding: moderateScale(4),
                                                                            //  margin:moderateScale(5),
                                                                            borderWidth: moderateScale(1),
                                                                            // borderRadius: moderateScale(2),
                                                                            borderColor: '#ddd',
                                                                            // borderBottomWidth: 0,
                                                                            // shadowColor: '#000',
                                                                            // shadowOffset: {width: 0, height: moderateScale(.7)},
                                                                            // shadowOpacity: 0.6,
                                                                            // shadowRadius: moderateScale(2),
                                                                            elevation: moderateScale(1),
                                                                            // marginLeft: moderateScale(1),
                                                                            // marginRight: moderateScale(1),
                                                                            // marginTop: moderateScale(1),
                                                                            // marginBottom: moderateScale(1),
                                                                            backgroundColor: Colors.white,
                                                                        }}>
                                                                        <View
                                                                            style={{
                                                                                width: '100%',
                                                                                flexDirection: 'row',
                                                                                backgroundColor: Colors.white,


                                                                                // alignSelf: 'center'
                                                                                // marginVertical:moderateScale(6),
                                                                            }}>


                                                                            <View
                                                                                style={{
                                                                                    flex: .4,
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    marginVertical: moderateScale(8),
                                                                                    //  paddingHorizontal: moderateScale(4)
                                                                                }}

                                                                            >
                                                                                <HMTextView
                                                                                    // numberOfLines={2}
                                                                                    type={"bold"}
                                                                                    text={item.name ? item.name : item.subject_name}
                                                                                    style={{
                                                                                        fontSize: moderateScale(13),

                                                                                        color: Colors.blue,
                                                                                    }}/>
                                                                            </View>
                                                                            <View style={{
                                                                                height: '100%',
                                                                                width: moderateScale(1),
                                                                                alignSelf: 'center',
                                                                                backgroundColor: Colors.light43
                                                                            }}/>

                                                                            <CustomView
                                                                                style={{
                                                                                    flex: .15,
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center'
                                                                                }}
                                                                                activeOpacity={mode ? .2 : 1}

                                                                            >
                                                                                <HMTextView
                                                                                    // numberOfLines={2}
                                                                                    type={"bold"}
                                                                                    text={item.count ? item.count : item.total_count}
                                                                                    style={[{
                                                                                        fontSize: moderateScale(14),
                                                                                        textAlign: "center",


                                                                                    }, mode ? {
                                                                                        color: Colors.blackLight,

                                                                                    } : {color: Colors.blackLight,}]}/>
                                                                            </CustomView>

                                                                            <View style={{
                                                                                height: '100%',
                                                                                width: moderateScale(1),
                                                                                alignSelf: 'center',
                                                                                backgroundColor: Colors.light43
                                                                            }}/>
                                                                            <View
                                                                                style={{
                                                                                    flex: .15,
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    marginVertical: moderateScale(2)
                                                                                }}>

                                                                                <CustomView
                                                                                    style={{
                                                                                        flex: .15,
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center'
                                                                                    }}
                                                                                    activeOpacity={mode ? .2 : 1}

                                                                                >

                                                                                    <HMTextView
                                                                                        // numberOfLines={2}
                                                                                        type={"bold"}
                                                                                        //text={(((item.doing ? item.doing : item.inprogress_count) / (item.count ? item.count : item.total_count)) * 100) + "%"}
                                                                                        text={Tools.getPercentage((item.doing ? item.doing : item.inprogress_count), (item.count ? item.count : item.total_count)) + "%"}
                                                                                        style={[{
                                                                                            fontSize: moderateScale(14),


                                                                                            //  marginTop: moderateScale(4),
                                                                                            textAlign: "center",


                                                                                        }, mode ? {
                                                                                            color: Colors.blackLight,
                                                                                            // textDecorationLine: "underline",
                                                                                            // textDecorationStyle: "solid",
                                                                                        } : {color: Colors.blackLight,}]}/>
                                                                                </CustomView>

                                                                            </View>
                                                                            <View style={{
                                                                                height: '100%',
                                                                                width: moderateScale(1),
                                                                                alignSelf: 'center',
                                                                                backgroundColor: Colors.light43
                                                                            }}/>
                                                                            <View
                                                                                style={{
                                                                                    flex: .15,
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    marginVertical: moderateScale(2)
                                                                                }}>
                                                                                <CustomView
                                                                                    style={{
                                                                                        flex: .15,
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center'
                                                                                    }}
                                                                                    activeOpacity={mode ? .2 : 1}

                                                                                >

                                                                                    <HMTextView
                                                                                        // numberOfLines={2}
                                                                                        type={"bold"}
                                                                                        //   text={(item.done ? item.done : item.done_count) + "%"}
                                                                                        text={Tools.getPercentage((item.done ? item.done : item.done_count), (item.count ? item.count : item.total_count)) + "%"}

                                                                                        style={[{
                                                                                            fontSize: moderateScale(14),
                                                                                            textAlign: "center",


                                                                                        }, mode ? {
                                                                                            color: Colors.blackLight,
                                                                                            // textDecorationLine: "underline",
                                                                                            // textDecorationStyle: "solid",
                                                                                        } : {color: Colors.blackLight,}]}/>
                                                                                </CustomView>

                                                                            </View>
                                                                            <View style={{
                                                                                height: '100%',
                                                                                width: moderateScale(1),
                                                                                alignSelf: 'center',
                                                                                backgroundColor: Colors.light43
                                                                            }}/>
                                                                            <View
                                                                                style={{
                                                                                    flex: .15,
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    marginVertical: moderateScale(2)
                                                                                }}>
                                                                                <CustomView
                                                                                    style={{
                                                                                        flex: .15,
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center'
                                                                                    }}
                                                                                    activeOpacity={mode ? .2 : 1}

                                                                                >

                                                                                    <HMTextView
                                                                                        // numberOfLines={2}
                                                                                        type={"bold"}
                                                                                        //    text={(item.other ? item.other : item.other_count) + "%"}
                                                                                        text={Tools.getPercentage((item.other ? item.other : item.other_count), (item.count ? item.count : item.total_count)) + "%"}

                                                                                        style={[{
                                                                                            fontSize: moderateScale(14),


                                                                                            //  marginTop: moderateScale(4),
                                                                                            textAlign: "center",


                                                                                        }, mode ? {
                                                                                            color: Colors.blackLight,
                                                                                            // textDecorationLine: "underline",
                                                                                            // textDecorationStyle: "solid",
                                                                                        } : {color: Colors.blackLight,}]}/>
                                                                                </CustomView>

                                                                            </View>
                                                                        </View>

                                                                    </View>
                                                                }}

                                                            />
                                                            :
                                                            null
                                                    }


                                                </View>
                                            </View>


                                        </View>

*/}

                                    </ScrollView>
                                    {
                                        this.state.isLoading ?
                                            <DialogLoadingCustomize/>
                                            : null
                                    }


                                    {
                                        this.props.NoInternetDialog ?
                                            <DialogConnectionCustomize onPress={() => this.getData()}/> : null
                                    }
                                </View>

                        }
                    </KeyboardAvoidingView>
                </View>
            </View>

        );
    }


    onPressSelectCheckBox(item, name, check) {

        let idx = container.state.arraySelectCheckBoxGender.findIndex(obj => obj.id === item.id);
        let arr = container.state.arraySelectCheckBoxGender;

        if (idx !== -1) {
            arr.splice(idx, 1)

            // container.setState({
            //         arraySelected: arr
            //     },
            //
            //     () => {
            //         //  container.state.arraySelected.slice(container.state.indexFilter, 1)
            //         container.state.arraySelected.push({
            //             index: container.state.indexFilter,
            //             data: data,
            //             id: data.id,
            //             value: data.name,
            //             type: container.state.typeFilter
            //         })
            //     }
            // )

        } else {
            container.state.arraySelectCheckBoxGender.push(item)
            // arr = [...newState.listFilter, {...action.data}]
            // newState.listFilter = arr
        }


        container.setState({
                //   ['indexSelectCheckBox' + name]: check ? null : (item.id ? item.id : item.value)
                ['indexSelectCheckBox' + name]: (item.id ? item.id : item.value),
            },
            () => {
            })
    }

    goScreen(route, item, position) {
        let checkLogin = (store.getState().reducerSplashGetAllData.TypeLogin == 2)

        container.setState({isLoading: false})
        NavigationService.navigateParams(route, {
            position: JSON.stringify(Tools.cloneAsObject(position)),
            //   position: JSON.stringify(position),
            //  position:position,
            typeComponent: checkLogin ? "Operation" : null,
            item: container.props.navigation && container.props.route && container.props.route.params ? container.props.route.params.item : JSON.stringify(item),
            data: JSON.stringify(item),
            type: route
        })
    }

    stateError() {
        container.setState({
            locationEnabled: false,
            isLoading: false,
        }, () => {
        })
    }


    convertDataChart() {
        let {Place} = this.state;
        let {top_subjects, top_subject_groups} = Place ? Place : {};

        let resultMonth = this.getMonthChartValue(this.state.SelectMonthValue);

        let resultSubjectList10 = top_subjects?.find(k => k.month.search('-' + resultMonth) >= 0);
        let resultSubjectList4 = top_subject_groups?.find(k => k.month.search('-' + resultMonth) >= 0);

        this.setState({
            listSubjectList10: top_subjects,
            listSubjectList4: top_subject_groups,

            SubjectList10: resultSubjectList10?.subjects,
            SubjectList4: resultSubjectList4?.subjects,

        })
        if (Place) {
            let result = Place.kpis;

            if (result)
                Object.keys(result).forEach(function (value, key) {
                    let array = [];
                    let arrayGroupBarChart = [];
                    let arrayGroupBarChart2 = [];
                    let month = [];
                    let text = +key + ' = ' + value;

                    let resultChild = result[value];
                    array = [];
                    arrayGroupBarChart = [];
                    arrayGroupBarChart2 = [];


                    Object.keys(resultChild).forEach(function (valueChild, keyChild) {
                        let textChild = +keyChild + ' = ' + valueChild;
                        month.push(container.getMonthChart(valueChild))
                        resultChild[valueChild].map((valChildSub, keyChildSub) => {
                            if (keyChildSub >= 7) {
                                return;
                            }
                            let idx = -1;
                            if (keyChild === 0) {
                                let value = valChildSub.satisfactio_percentage ? valChildSub.satisfactio_percentage : valChildSub.achieved_score_percentage;

                                if (key === 0) {
                                    array.push({
                                        id: valChildSub.place_id,
                                        label: valChildSub.place_name,
                                        data: [value],
                                        values: [{x: keyChild, y: parseInt(value) > 0 ? parseInt(value) : 0}],

                                        //values: [valChildSub.satisfactio_percentage ? valChildSub.satisfactio_percentage : valChildSub.achieved_score_percentage],
                                        borderColor: container.getColorChart(keyChildSub),
                                        //  backgroundColor: 'rgba(50, 50, 8, 0.5)',
                                        backgroundColor: container.getColorChart(keyChildSub),
                                        yAxisID: 'y-axis-' + (keyChild + 1),
                                        lineTension: 0,
                                        fill: false,


                                        //android_ios
                                        config: {
                                            drawValues: false,
                                            colors: [processColor(container.getColorChart(keyChildSub))],
                                            circleColor: processColor(container.getColorChart(keyChildSub)),
                                            circleRadius: 5,
                                        }
                                    })
                                }
                                else {
                                    array.push({
                                        id: valChildSub.place_id,
                                        label: valChildSub.place_name,
                                        data: [value],
                                        values: [{x: keyChild, y: parseInt(value) > 0 ? parseInt(value) : 0}],
                                        borderColor: container.getColorChart(keyChildSub),
                                        //  backgroundColor: 'rgba(50, 50, 8, 0.5)',
                                        //  backgroundColor: container.getColorChart(keyChildSub),
                                        backgroundColor: container.getColorChart(keyChildSub),
                                        //yAxisID: 'y-axis-' + (keyChild + 1),
                                        lineTension: 0,
                                        fill: false,

                                        //android_ios
                                        config: {
                                            drawValues: false,
                                            colors: [processColor(container.getColorChart(keyChildSub))],
                                            circleColor: processColor(container.getColorChart(keyChildSub)),
                                            circleRadius: 5,
                                        }
                                    })

                                    arrayGroupBarChart.push({
                                        id: valChildSub.place_id,
                                        label: valChildSub.place_name,
                                        data: [parseInt(value) > 0 ? parseInt(value) : 0],
                                        values: [parseInt(value) > 0 ? parseInt(value) : 0],
                                        //borderColor: container.getColorChart(keyChildSub),
                                        //  backgroundColor: 'rgba(50, 50, 8, 0.5)',
                                        //  backgroundColor: container.getColorChart(keyChildSub),
                                        backgroundColor: container.getColorChart(keyChildSub),
                                        //yAxisID: 'y-axis-' + (keyChild + 1),
                                        //lineTension: 0,


                                        //android_ios
                                        config: {
                                            drawValues: false,
                                            colors: [processColor(container.getColorChart(keyChildSub))],
                                            circleColor: processColor(container.getColorChart(keyChildSub)),
                                            circleRadius: 5,
                                            // barWidth: 0.31,
                                            // group: {
                                            //     fromX: 0,
                                            //     groupSpace: 0.12,
                                            //     barSpace: 0.13,
                                            // },
                                        }


                                    })
                                }


                            }
                            else {
                                let value = valChildSub.satisfactio_percentage ? valChildSub.satisfactio_percentage : valChildSub.achieved_score_percentage;

                                idx = array.findIndex(obj => obj.id === valChildSub.place_id);
                                if (idx !== -1) {
                                    array[idx].data.push(value);

                                    //arrayGroupBarChart[idx].data.push(valChildSub.satisfactio_percentage ? valChildSub.satisfactio_percentage : valChildSub.achieved_score_percentage);
                                    if (key !== 0) {
                                        array[idx].values.push({
                                            x: keyChild,
                                            y: parseInt(value) > 0 ? parseInt(value) : 0
                                        });
                                        arrayGroupBarChart[idx].data.push(value);
                                        // arrayGroupBarChart[idx].values.push(valChildSub.satisfactio_percentage ? valChildSub.satisfactio_percentage : valChildSub.achieved_score_percentage);
                                        arrayGroupBarChart[idx].values.push(parseInt(value) > 0 ? parseInt(value) : 0);
                                    }
                                    else {
                                        array[idx].values.push({
                                            x: keyChild,
                                            y: parseInt(value) > 0 ? parseInt(value) : 0
                                        });

                                    }

                                }


                            }

                        });

                    })

                    let nameDataSets = Platform.OS === "web" ? "datasets" : "dataSets";
                    if (key === 0)
                        container.setState({
                            dataChart: {
                                labels: month,
                                [nameDataSets]: array.length > 2 ? array.slice(0, 2) : array,
                            },

                            dataChart2: {
                                labels: month,
                                [nameDataSets]: array,


                            }
                        })
                    else {


                        container.setState({
                                dataChart3: {
                                    labels: month,
                                    [nameDataSets]: array,
                                },

                                dataChartGroupBarChart: {
                                    labels: month,
                                    [nameDataSets]: arrayGroupBarChart.length > 2 ? arrayGroupBarChart.slice(0, 2) : arrayGroupBarChart,
                                    // config: {
                                    //     barWidth: 0.31,
                                    //     group: {
                                    //         fromX: 0,
                                    //         groupSpace: 0.12,
                                    //         barSpace: 0.13,
                                    //     },
                                    //
                                    //
                                    // }
                                    config: {
                                        barWidth: (month.length < 6 ? 0.062 : (month.length > 9 ? 0.022 : 0.038)) * month.length,
                                        group: {
                                            fromX: 0,
                                            groupSpace: (month.length < 6 ? .012 : (month.length > 9 ? .01 : .011)) * month.length,
                                            // barSpace: (month.length < 6 ? .026 : (month.length > 9 ? .01 : .015)) * month.length,
                                            barSpace: ((month.length < 6 ? .65 : (month.length > 9 ? 2.1 : 1.8)) / month.length),
                                        },


                                    }
                                },
                            },
                            () => {

                            }
                        )
                    }

                })


        }
    }

    getColorChart(index) {
        switch (index) {
            case 0 :
                return "#1ca823";
            case 1 :
                return "#a89207";
            case 2 :
                return "#a82112";
            case 3 :
                return "#a80b9c";
            case 4 :
                return "#3e0aa8";
            case 5 :
                return "#1e9ca8";
            case 6 :
                return "#393939";
            case 7 :
                return "#a8663a";

            default :
                return "#9685a8";
        }
    }

    getMonthChart(data) {
        let res = data.substr(5, 2)

        switch (res) {
            case "01" :
                return "فروردین";
            case "02" :
                return "اردیبهشت";
            case "03" :
                return "خرداد";
            case "04" :
                return "تیر";
            case "05" :
                return "مرداد";
            case "06" :
                return "شهریور";
            case "07" :
                return "مهر";
            case "08" :
                return "آبان";
            case "09" :
                return "آذر";
            case "10" :
                return "دی";
            case "11" :
                return "بهمن";
            case "12" :
                return "اسفند";


            default :
                return "##";
        }
    }

    getMonthChartValue(data) {
        //let res = data.substr(5, 2)

        switch (data) {
            case "فروردین" :
                return "01";
            case "اردیبهشت" :
                return "02";
            case "خرداد" :
                return "03";
            case "تیر" :
                return "04";
            case "مرداد" :
                return "05";
            case "شهریور" :
                return "06";
            case "مهر" :
                return "07";
            case "آبان" :
                return "08";
            case "آذر" :
                return "09";
            case "دی" :
                return "10";
            case "بهمن" :
                return "11";
            case "اسفند" :
                return "12";


            default :
                return "##";
        }
    }


    getDataDashboard(func) {

        let {item} = this.props.route.params;
        if (item && item.id) {
            return;
        }
        let formData = new FormData();
        formData.append('_operation', typeExport._Shahrdar);
        formData.append('mode', "GetDashboard");
        formData.append('lang', i18n.locale);
        formData.append('token', container.props.DataSplashScreen.token);
        formData.append('tokenLaravel', container.props.DataSplashScreen.tokenLaravel);

        if (item && item.id) {
            formData.append('with_places', 1);
            formData.append('ids[]', [item.id]);
        }
        Tools.addAllFormData(formData, true);

        //   formData.append('ids[]', JSON.stringify(`[${item.id}]`));

        //  formData.append('record', itemParams.RequestID);
        container.requestServer(
            formData, (item) => {
                // dddd = JSON.parse(dddd)
                item = item.dashboard_pattern;


                let month = item.places[1].top_subject_groups[0].month;
                let nameMonth = this.getMonthChart(month);
                container.setState({
                    SelectPlaceValue: item && item.places && item.places.length > 0 ? item.places[1].value : null,
                    Place: item && item.places && item.places.length > 0 ? item.places[1] : null,
                    widgets: item && item.places && item.widgets.length > 0 ? item.widgets : [],
                    listPlace: item && item.places && item.places.length > 0 ? item.places : [],
                    SubjectList10: item.places[1].top_subjects[0].subjects,
                    SubjectList4: item.places[1].top_subject_groups[0].subjects,

                    Month: {
                        label: nameMonth,
                        value: nameMonth,
                        index: 0
                    },
                    SelectMonthValue: nameMonth,

                    Month4: {
                        label: nameMonth,
                        value: nameMonth,
                        index: 0
                    },
                    SelectMonthValue4: nameMonth,
                    Month10: {
                        label: nameMonth,
                        value: nameMonth,
                        index: 0
                    },
                    SelectMonthValue10: nameMonth,

                    listSubjectList10: item.places[1].top_subjects,
                    listSubjectList4: item.places[1].top_subject_groups,
                    //  resultChart:item && item.places && item.places.length > 0 ? item.places : [],
                    // List: item.result && item.result.list && item.result.list.length > 0 ? item.result.list : [],
                }, () => {
                    this.convertDataChart();

                    func ? func() : null
                })
            }, null
        );
    }

    requestServer(formData, func, noLoading) {

        container.setState({
            //ShowImage:true
            isLoading: !noLoading,
            NoInternetDialog: false,
            results: null


        })


        // const formData = new FormData();
        // formData.append('lang', i18n.locale);
        // formData.append('token', container.props.token);


        axios({
            method: 'post',
            url: typeExport._baseUrlSainaShahrdar,
            data: formData,
            headers: {'Content-Type': 'multipart/form-data'},
            timeout: typeExport._TIMEOUT,

        })
        //   axios.post(typeExport._baseUrlSatia + "ibs/littlemore", formData, config)
            .then(async response => {
                let data = response.data;

                // fruits.forEach (function(value, key) {
                //     text += key + ' = ' + value;
                // })
                // data.status ? this.state.listImage.push(image) : null;

                if (data.success) {
                    func ? func(data.result) : null
                    // container.getDataServerSplash()
                }
                else {
                    /*    HMAlert(
                            i18n.t('constant.message'),
                            data.message,
                            [
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {

                                    }


                                },

                            ],
                            {cancelable: true}
                        )*/
                }
                container.setState({
                    //ShowImage:true
                    //list: data.status ? list : this.state.list,
                    //TypeDocumentsList:[],
                    isLoading: false,
                    NoInternetDialog: !data.success,

                })
            }).catch((e) => {
            console.log('error', e)

            // HMAlert(
            //     i18n.t('constant.message'),
            //     "خطا در ارتباط با سرور لطفا مجددا تلاش نمایید",
            //     [
            //         {
            //             text: i18n.t('constant.ok'), onPress: () => {
            //
            //             }
            //
            //
            //         },
            //
            //     ],
            //     {cancelable: true}
            // )
            container.setState({
                //ShowImage:true
                isLoading: false,
                NoInternetDialog: true,

            })
        })
    }


}

const mapStateToProps = (state) => {

    return {
        DataSplashScreen: state.reducerSplashGetAllData,
        token: state.reducerSplashGetAllData.token,


    }
}
const mapDispatchToProps = dispatch => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(DashboardMyStateScreen);
